import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout/Layout';
import { useUser } from '../contexts/UserContext';
import api from '../utils/api';
import toast from 'react-hot-toast';
import {
    FiUsers, FiUserCheck, FiClock, FiCheckCircle,
    FiChevronLeft, FiChevronRight, FiX, FiCalendar, FiRotateCcw, FiServer,
    FiPhone, FiMail, FiBriefcase, FiToggleLeft, FiToggleRight, FiSearch, FiGitCommit,
    FiDownload, FiChevronUp, FiChevronDown, FiFilter, FiArrowUp, FiArrowDown, FiGitMerge, FiCreditCard, FiFlag, FiPhoneCall, FiAward
} from 'react-icons/fi';
import * as HighchartsExporting from 'highcharts/modules/exporting';

// Initialize exporting module safely
if (typeof HighchartsExporting === 'function') {
    HighchartsExporting(Highcharts);
} else if (HighchartsExporting && typeof HighchartsExporting.default === 'function') {
    HighchartsExporting.default(Highcharts);
}
import { FaIdCard } from 'react-icons/fa';
import IdCard from './feature/Id_card';
import { RiFilePdf2Fill, RiFileExcelFill, RiUser3Fill } from "react-icons/ri";
import { motion, AnimatePresence } from 'framer-motion';

import OverallTicketChart from '../charts/OverallTicketChart';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { differenceInYears, differenceInMonths } from 'date-fns';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import EmployeeDetails from './employee_details';
import GitActivity from './git/Git_activity';
import LeaveManagement from './hrms/LeaveManagement';
import AttendanceDashboard from './hrms/AttendanceDashboard';
import HrNotes from './hrms/HrNotes';
import AssessmentPopup from './assessment/dashboard/AssessmentPopup';
// import DynamicTable from './Emp_review';

import MissingStatusReport from '../charts/MissingStatusReport';
import MissingOutPunchChart from '../charts/MissingOutPunchChart';
import CompanyOverviewCharts from '../charts/CompanyOverviewCharts';
import VerticalHeadsOverview from '../charts/VerticalHeadsOverview';
// import EmployeeTicketStatusOverview from '../charts/EmployeeTicketStatusOverview';
import Leadtickettrends from '../charts/Leadtickettrends';
import EmployeeGitActivity from '../charts/employee_git_activity';
import TicketDelayAnalytics from '../charts/TicketDelayAnalytics';
import Verticalhead_wise_tickets from '../charts/Verticalhead_wise_tickets';
import Verticalhead_workload_overview from '../charts/Verticalhead_workload_overview';
import Select from 'react-select';
// import GeoAttendance from './GeoAttendance';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const headerMonths = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
const headerYears = Array.from({ length: 21 }, (_, i) => new Date().getFullYear() - 20 + i);

const formatDateToString = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const formatTime = (timeStr) => {
    if (!timeStr) return '';
    const parts = timeStr.split(':');
    if (parts.length < 2) return timeStr;
    let hours = parseInt(parts[0], 10);
    const minutes = parts[1];
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return `${hours}:${minutes} ${ampm}`;
};

const getAssignedDateOnly = (dateTimeStr) => {
    if (!dateTimeStr) return '';
    return dateTimeStr.split(' ')[0] || dateTimeStr.split('T')[0];
};



function HrmsDashboard() {
    const { user } = useUser();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const getNormalizedTab = (tabVal) => {
        if (!tabVal) return 'overview';
        if (tabVal.startsWith('leaves')) return 'leaves';
        return tabVal;
    };

    const [activeTab, setActiveTab] = useState(getNormalizedTab(searchParams.get('tab')));

    useEffect(() => {
        const tab = searchParams.get('tab');
        const normalized = getNormalizedTab(tab);
        if (normalized && normalized !== activeTab) {
            setActiveTab(normalized);
        }
    }, [searchParams]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setSearchParams({ tab });
    };

    // Role checks
    const roleIdRaw = user?.user_role_id ?? user?.role_id;
    const roleId = parseInt(roleIdRaw);
    const userId = user?.user_id;

    const [leaveStats, setLeaveStats] = useState({ total_actionable: 0 });
    const [perfRevisionUnread, setPerfRevisionUnread] = useState(0);
    const [hrNotesUnreadCount, setHrNotesUnreadCount] = useState(0);

    const fetchLeaveStats = async () => {
        if (!userId || !roleId) return;
        try {
            const res = await api.get('/hrms/leave-stats', { params: { user_id: userId, role_id: roleId } });
            if (res.data.status) {
                setLeaveStats(res.data.data);
            }
        } catch (e) { console.error('Error fetching leave stats:', e); }
    };

    const fetchPerfRevisionAlerts = async () => {
        if (!userId || !roleId) return;
        try {
            const res = await api.get('/employee/performance-revision-alerts');
            if (res.data.status) {
                setPerfRevisionUnread(Number(res.data.data?.unread_count) || 0);
            }
        } catch (e) { console.error('Error fetching performance revision alerts:', e); }
    };

    useEffect(() => {
        fetchLeaveStats();
        fetchPerfRevisionAlerts();
        // Periodically refresh stats for badge
        const interval = setInterval(() => {
            fetchLeaveStats();
            fetchPerfRevisionAlerts();
        }, 60000);
        const onPerfRevisionAlertsChanged = () => fetchPerfRevisionAlerts();
        window.addEventListener('perf-revision-alerts-changed', onPerfRevisionAlertsChanged);
        return () => {
            clearInterval(interval);
            window.removeEventListener('perf-revision-alerts-changed', onPerfRevisionAlertsChanged);
        };
    }, [userId, roleId]);

    const isHROrAdmin = user && [1].includes(roleId);
    const isAttendanceManager = user && roleId === 13;
    const hasAttendanceDashboardAccess = user && [1, 13, 9].includes(roleId);
    const hasGitlabAccess = user && [1, 6].includes(roleId);
    const isClient = user && roleId === 2;
    const isEmployee = user && !isHROrAdmin && !isClient;
    const designationId = parseInt(user?.designation_id || 0);
    const hasLeadTrendsAccess = isHROrAdmin || [26, 42, 43, 24].includes(designationId) || userId == 111;

    // HR Notes Popup Notification
    const [popupNote, setPopupNote] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupAckSuccess, setPopupAckSuccess] = useState(false);
    const [replyText, setReplyText] = useState('');
    const [flashNotes, setFlashNotes] = useState([]);
    const [selectedFlashNote, setSelectedFlashNote] = useState(null);

    // LMS Test Assignment Popup — independent of HR Notes
    const [lmsPopupQueue, setLmsPopupQueue] = useState([]);
    const [showLmsPopup, setShowLmsPopup] = useState(false);
    const [currentLmsNotif, setCurrentLmsNotif] = useState(null);
    const [lmsNotifications, setLmsNotifications] = useState([]);
    const [allLmsTests, setAllLmsTests] = useState([]);

    const fetchAllLmsTests = useCallback(async () => {
        if (!userId || roleId === 2) return;
        try {
            const res = await api.get('/assessment/getStudentAssessments');
            if (res.data.status === 'success' && Array.isArray(res.data.assessments)) {
                const normalized = res.data.assessments.map(item => ({
                    ...item,
                    id: item.id,
                    test_name: item.assessment_name || item.pack_name || 'LMS Test',
                }));
                setAllLmsTests(normalized);
            }
        } catch (e) {
            console.error('Error fetching all LMS tests:', e);
        }
    }, [userId, roleId]);

    const isLmsNotifLive = useCallback((notif) => {
        if (!notif) return false;
        if (!notif.scheduled_date || !notif.start_time || !notif.end_time) return true;
        const now = new Date();
        const startDateTime = new Date(`${notif.scheduled_date}T${notif.start_time}`);
        const endDateTime = new Date(`${notif.scheduled_date}T${notif.end_time}`);
        return now >= startDateTime && now <= endDateTime;
    }, []);

    const checkLmsNotifications = useCallback(async () => {
        if (!userId || roleId === 2 || isHROrAdmin) return;
        try {
            const res = await api.get('/assessment/lms-notifications');
            if (res.data.status && Array.isArray(res.data.notifications)) {
                const processed = res.data.notifications;
                setLmsNotifications(processed);
                if (!showLmsPopup) {
                    const unread = processed.filter((n) => {
                        if (n.read_status !== 'Unread') return false;
                        if (!isLmsNotifLive(n)) return false;
                        const key = `lms_notif_dismissed_${n.id}`;
                        return !sessionStorage.getItem(key);
                    });
                    if (unread.length > 0) {
                        setLmsPopupQueue(unread);
                        setCurrentLmsNotif(unread[0]);
                        setShowLmsPopup(true);
                    }
                }
            }
        } catch (e) {
            console.error('Error checking LMS notifications:', e);
        }
    }, [userId, roleId, isLmsNotifLive, showLmsPopup, isHROrAdmin]);

    const dismissLmsPopup = useCallback(async () => {
        if (currentLmsNotif) {
            // Mark as read in backend
            try {
                await api.post('/assessment/lms-notifications/read', { id: currentLmsNotif.id });
            } catch (e) { /* silent */ }
            sessionStorage.setItem(`lms_notif_dismissed_${currentLmsNotif.id}`, '1');
            window.dispatchEvent(new CustomEvent('lms-notifications-changed'));
        }
        // Show next in queue if any
        const remaining = lmsPopupQueue.filter((n) => String(n.id) !== String(currentLmsNotif?.id));
        if (remaining.length > 0) {
            setLmsPopupQueue(remaining);
            setCurrentLmsNotif(remaining[0]);
        } else {
            setShowLmsPopup(false);
            setCurrentLmsNotif(null);
            setLmsPopupQueue([]);
        }
    }, [currentLmsNotif, lmsPopupQueue]);

    const handleTakeTest = useCallback(async (notif) => {
        const targetNotif = (notif && (notif.id || notif.notification_id)) ? notif : currentLmsNotif;
        if (targetNotif) {
            const notifId = targetNotif.id || targetNotif.notification_id;
            if (notifId) {
                try {
                    await api.post('/assessment/lms-notifications/read', { id: notifId });
                } catch (e) { /* silent */ }

                sessionStorage.setItem(`lms_notif_dismissed_${notifId}`, '1');

                setLmsNotifications((prev) =>
                    prev.map((n) => (String(n.id) === String(notifId) ? { ...n, read_status: 'Read' } : n))
                );
                window.dispatchEvent(new CustomEvent('lms-notifications-changed'));
            }
        }
        setShowLmsPopup(false);
        setCurrentLmsNotif(null);
        setLmsPopupQueue([]);
        navigate('/assessment');
    }, [currentLmsNotif, navigate]);


    useEffect(() => {
        // Slight delay so HR Notes popup (if any) loads first — they are visually stacked
        const t1 = setTimeout(checkLmsNotifications, 1500);
        const t2 = setTimeout(fetchAllLmsTests, 1500);

        // Periodically check for new LMS notifications every 30 seconds
        const interval1 = setInterval(checkLmsNotifications, 30000);
        const interval2 = setInterval(fetchAllLmsTests, 30000);

        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearInterval(interval1);
            clearInterval(interval2);
        };
    }, [checkLmsNotifications, fetchAllLmsTests]);

    const checkActiveNotes = useCallback(async () => {
        if (!userId || roleId === 2) return;
        try {
            const res = await api.get('/hrms/notes/active');
            if (res.data.status) {
                const recent = res.data.data.recent || [];
                const unreadNotesCount = recent.filter(
                    (n) => n.read_status === 'Unread' || n.read_status === 'Pending'
                ).length;
                setHrNotesUnreadCount(unreadNotesCount);

                const today = new Date().toISOString().slice(0, 10);
                // expiry_date only controls the scrolling flash strip — not the HR Notes list
                const globalEvents = recent.filter(note => {
                    if (note.message_type !== 'Global Announcement') return false;
                    if (!['event', 'celebration', 'notification'].includes(note.category)) return false;
                    if (note.expiry_date && String(note.expiry_date).slice(0, 10) < today) return false;
                    if (note.effective_date && String(note.effective_date).slice(0, 10) > today) return false;
                    return true;
                });
                setFlashNotes(globalEvents);

                // Auto-read any unread flash notes
                for (const note of globalEvents) {
                    if (note.read_status === 'Unread' || note.read_status === 'Pending') {
                        try {
                            await api.post('/hrms/notes/read', { note_id: note.id });
                        } catch (err) {
                            console.error('Error auto-reading flash note:', err);
                        }
                    }
                }

                if (res.data.data.popup && !isHROrAdmin) {
                    const note = res.data.data.popup;
                    // Check if already dismissed in this session
                    const dismissed = sessionStorage.getItem(`hr_note_dismissed_${note.id}`);
                    if (!dismissed) {
                        setPopupNote(note);
                        setShowPopup(true);

                        // Mark as read in backend
                        if (note.read_status === 'Unread' || note.read_status === 'Pending') {
                            await api.post('/hrms/notes/read', { note_id: note.id });
                        }
                    } else {
                        setPopupNote(null);
                        setShowPopup(false);
                    }
                } else {
                    setPopupNote(null);
                    setShowPopup(false);
                }
            } else {
                setPopupNote(null);
                setShowPopup(false);
                setFlashNotes([]);
                setHrNotesUnreadCount(0);
            }
        } catch (e) {
            console.error('Error checking active notes popup:', e);
        }
    }, [userId, roleId, isHROrAdmin]);

    useEffect(() => {
        checkActiveNotes();
    }, [checkActiveNotes]);

    const handleAcknowledgePopup = async () => {
        if (!popupNote) return;
        try {
            const res = await api.post('/hrms/notes/acknowledge', {
                note_id: popupNote.id,
                employee_reply: replyText
            });
            if (res.data.status) {
                setPopupAckSuccess(true);
                toast.success('Note acknowledged successfully');
                setTimeout(() => {
                    setShowPopup(false);
                    setPopupNote(null);
                    setPopupAckSuccess(false);
                    setReplyText('');
                    checkActiveNotes();
                }, 1500);
            }
        } catch (e) {
            console.error('Popup acknowledge error:', e);
            toast.error('Failed to acknowledge note');
        }
    };


    // Remove the redirect for role 13 since they are now also treated as employees

    return (
        <Layout noSidebar={true}>
            <div className={`bg-gray-50 min-h-screen flex flex-col ${activeTab === 'profile' ? '' : ''}`}>

                {/* Flash News Marquee */}
                {roleIdRaw != 2 && (
                    <div className="w-full flex justify-end px-3 sm:px-6 pt-3 flex-shrink-0">
                        <div
                            style={{ transform: 'skewX(-20deg)' }}
                            className="w-full md:w-1/2 bg-white border border-gray-200 flex items-center relative overflow-hidden h-9 shadow-sm"
                        >
                            {/* Badge Container */}
                            <div className="absolute left-0 top-0 bottom-0 z-10 flex items-center bg-main pr-4 pl-6 shadow-md">
                                <span
                                    style={{ transform: 'skewX(20deg)' }}
                                    className="text-white font-extrabold text-[10px] sm:text-xs uppercase tracking-wider select-none whitespace-nowrap"
                                >
                                    Flash News
                                </span>
                            </div>

                            {/* Marquee Container */}
                            <div
                                style={{ transform: 'skewX(20deg)' }}
                                className="flex-1 overflow-hidden h-full flex items-center pl-28 sm:pl-32 pr-16 relative"
                            >
                                {flashNotes && flashNotes.length > 0 && (
                                    <div className="whitespace-nowrap flex items-center gap-12 animate-marquee cursor-pointer">
                                        {flashNotes.map((note, index) => (
                                            <div
                                                key={`${note.id}-${index}`}
                                                className="inline-flex items-center gap-2 text-xs font-semibold text-gray-800"
                                                onClick={() => setSelectedFlashNote(note)}
                                            >
                                                <span className="w-1.5 h-1.5 rounded-full bg-main animate-ping" />
                                                <span className="hover:underline hover:text-main transition-colors">
                                                    {note.title}
                                                </span>
                                                {note.priority === 'Critical' && (
                                                    <span className="bg-red-100 text-red-700 text-[9px] px-1.5 py-0.5 rounded font-bold uppercase tracking-wide">
                                                        Critical
                                                    </span>
                                                )}
                                                {note.priority === 'Important' && (
                                                    <span className="bg-orange-100 text-orange-700 text-[9px] px-1.5 py-0.5 rounded font-bold uppercase tracking-wide">
                                                        Important
                                                    </span>
                                                )}
                                                {index < flashNotes.length - 1 && <span className="text-gray-300 select-none">|</span>}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* View All Link (only for non-clients) */}
                            {roleIdRaw != 2 && (
                                <div className="absolute right-0 top-0 bottom-0 flex items-center bg-white pl-2 pr-3 z-10 shadow-[-8px_0_8px_-4px_rgba(255,255,255,1)]">
                                    <span
                                        onClick={() => handleTabChange('notes')}
                                        style={{ transform: 'skewX(20deg)' }}
                                        className="text-xs font-bold text-blue-600 hover:text-blue-800 hover:underline cursor-pointer select-none whitespace-nowrap"
                                    >
                                        View All
                                    </span>
                                </div>
                            )}

                            {/* CSS Keyframes for marquee */}
                            {flashNotes && flashNotes.length > 0 && (
                                <style dangerouslySetInnerHTML={{
                                    __html: `
                                    @keyframes marquee {
                                        0% { left: 100%; transform: translate3d(0, 0, 0); }
                                        100% { left: 0; transform: translate3d(-100%, 0, 0); }
                                    }
                                    .animate-marquee {
                                        position: absolute;
                                        top: 0;
                                        bottom: 0;
                                        display: inline-flex;
                                        align-items: center;
                                        white-space: nowrap;
                                        animation: marquee 18s linear infinite;
                                    }
                                    .animate-marquee:hover {
                                        animation-play-state: paused;
                                    }
                                `}} />
                            )}
                        </div>
                    </div>
                )}

                {/* Header & Tabs Container */}
                {(() => {
                    const unreadLmsCount = isHROrAdmin ? 0 : lmsNotifications.filter((n) => n.read_status === 'Unread').length;
                    const unreadHrNotesCountFinal = isHROrAdmin ? 0 : hrNotesUnreadCount;
                    const perfRevisionUnreadFinal = perfRevisionUnread;
                    const employeeOverallUnread = isHROrAdmin ? perfRevisionUnreadFinal : (unreadHrNotesCountFinal + unreadLmsCount + perfRevisionUnreadFinal);

                    return (
                        <div className="px-3 sm:px-6 pt-3 sm:pt-6 pb-2">
                            {/* Header */}
                            <div className="mb-3 sm:mb-6 flex flex-col md:flex-row md:items-end justify-between gap-4">
                                <div>
                                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
                                        {isHROrAdmin ? 'HRMS Dashboard' : (isAttendanceManager ? 'Attendance Manager' : 'Employee Dashboard')}
                                    </h1>
                                    <p className="text-sm sm:text-base text-gray-600 mt-1">
                                        {isHROrAdmin ? 'Human Resource Management System' : (isAttendanceManager ? 'Attendance Manager Dashboard' : 'Employee Dashboard Overview')}
                                    </p>
                                </div>
                            </div>

                            {/* Tabs */}
                            <div className="flex flex-wrap gap-1 border-b border-gray-200">
                                <button
                                    onClick={() => handleTabChange('overview')}
                                    className={`px-3 py-2 font-medium text-xs md:text-sm md:px-4 transition-colors rounded-t-lg ${activeTab === 'overview'
                                        ? 'bg-white text-[#C30010] border border-gray-200 border-b-white -mb-px font-bold'
                                        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                        }`}
                                >
                                    Overview
                                </button>
                                {isHROrAdmin && (
                                    <button
                                        onClick={() => handleTabChange('employees')}
                                        className={`px-3 py-2 font-medium text-xs md:text-sm md:px-4 transition-colors rounded-t-lg relative flex items-center gap-1.5 ${activeTab === 'employees'
                                            ? 'bg-white text-[#C30010] border border-gray-200 border-b-white -mb-px font-bold'
                                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                            }`}
                                    >
                                        Employee Details
                                        {perfRevisionUnread > 0 && (
                                            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white ring-2 ring-white">
                                                {perfRevisionUnread > 99 ? '99+' : perfRevisionUnread}
                                            </span>
                                        )}
                                    </button>
                                )}
                                {hasGitlabAccess && (
                                    <button
                                        onClick={() => handleTabChange('gitlab')}
                                        className={`px-3 py-2 font-medium text-xs md:text-sm md:px-4 transition-colors rounded-t-lg ${activeTab === 'gitlab'
                                            ? 'bg-white text-[#C30010] border border-gray-200 border-b-white -mb-px font-bold'
                                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                            }`}
                                    >
                                        GitLab Activity
                                    </button>
                                )}
                                {isEmployee && (
                                    <button
                                        onClick={() => handleTabChange('profile')}
                                        className={`px-3 py-2 font-medium text-xs md:text-sm md:px-4 transition-colors rounded-t-lg relative flex items-center gap-1.5 ${activeTab === 'profile'
                                            ? 'bg-white text-[#C30010] border border-gray-200 border-b-white -mb-px font-bold'
                                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                            }`}
                                    >
                                        Profile
                                        {employeeOverallUnread > 0 && (
                                            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white ring-2 ring-white">
                                                {employeeOverallUnread > 99 ? '99+' : employeeOverallUnread}
                                            </span>
                                        )}
                                    </button>
                                )}
                                <button
                                    onClick={() => handleTabChange('leaves')}
                                    className={`px-3 py-2 font-medium text-xs md:text-sm md:px-4 transition-colors rounded-t-lg relative flex items-center gap-1.5 ${activeTab === 'leaves'
                                        ? 'bg-white text-[#C30010] border border-gray-200 border-b-white -mb-px font-bold'
                                        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                        }`}
                                >
                                    Leave Management
                                    {leaveStats.pending_approvals > 0 && (
                                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white ring-2 ring-white">
                                            {leaveStats.pending_approvals}
                                        </span>
                                    )}
                                </button>
                                {hasAttendanceDashboardAccess && (
                                    <button
                                        onClick={() => handleTabChange('attendance')}
                                        className={`px-3 py-2 font-medium text-xs md:text-sm md:px-4 transition-colors rounded-t-lg ${activeTab === 'attendance'
                                            ? 'bg-white text-[#C30010] border border-gray-200 border-b-white -mb-px font-bold'
                                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                            }`}
                                    >
                                        Attendance Dashboard
                                    </button>
                                )}
                                {roleIdRaw != 2 && (
                                    <button
                                        onClick={() => handleTabChange('notes')}
                                        className={`px-3 py-2 font-medium text-xs md:text-sm md:px-4 transition-colors rounded-t-lg ${activeTab === 'notes'
                                            ? 'bg-white text-[#C30010] border border-gray-200 border-b-white -mb-px font-bold'
                                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                            }`}
                                    >
                                        HR Notes
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })()}

                {/* Content Area - Logic for Spacing depending on Tab */}
                <div className="flex-1">
                    {activeTab === 'overview' && (
                        <div className="px-3 sm:px-6 pb-6 pt-2 sm:pt-4">
                            <DashboardOverview
                                user={user}
                                isHROrAdmin={isHROrAdmin}
                                userId={userId}
                                roleId={roleId}
                                designationId={designationId}
                                setActiveTab={handleTabChange}
                                lmsNotifications={lmsNotifications}
                                allLmsTests={allLmsTests}
                                refreshLmsNotifications={async () => {
                                    await checkLmsNotifications();
                                    await fetchAllLmsTests();
                                }}
                                handleTakeTest={handleTakeTest}
                                formatTime={formatTime}
                            />
                        </div>
                    )}

                    {isHROrAdmin && activeTab === 'employees' && (
                        <div className="px-6 pb-6 pt-4">
                            <EmployeeListTab />
                        </div>
                    )}

                    {hasGitlabAccess && activeTab === 'gitlab' && (
                        <div className="px-6 pb-6 pt-4">
                            <GitActivity />
                        </div>
                    )}

                    {isEmployee && activeTab === 'profile' && (
                        <EmployeeDetails />
                    )}
                    {activeTab === 'leaves' && (
                        <div className="px-6 pb-6 pt-4">
                            <LeaveManagement user={user} isHROrAdmin={isHROrAdmin} initialStats={leaveStats} onStatsUpdate={fetchLeaveStats} />
                        </div>
                    )}

                    {hasAttendanceDashboardAccess && activeTab === 'attendance' && (
                        <div className="px-6 pb-6 pt-4">
                            <AttendanceDashboard />
                        </div>
                    )}

                    {roleIdRaw != 2 && activeTab === 'notes' && (
                        <div className="px-6 pb-6 pt-4">
                            <HrNotes />
                        </div>
                    )}
                </div>
            </div>

            {showPopup && popupNote && (
                <div className="fixed inset-0 bg-black/60 z-[999] flex items-center justify-center p-4">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-[650px] overflow-hidden text-sm flex flex-col max-h-[85vh]">

                        {/* Header */}
                        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
                            <span className="flex items-center gap-2 font-bold text-gray-800 text-base">
                                📢 HR Announcement
                            </span>
                            <div className="flex items-center gap-1.5">
                                <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${popupNote.priority === 'Critical'
                                    ? 'bg-red-100 text-red-800'
                                    : (popupNote.priority === 'Important' ? 'bg-orange-100 text-orange-800' : 'bg-blue-100 text-blue-800')
                                    }`}>
                                    {popupNote.priority}
                                </span>
                                {popupNote.message_type === 'Individual Employee' && (
                                    <span className="bg-indigo-100 text-indigo-800 px-2.5 py-0.5 rounded-full text-xs font-bold flex items-center gap-0.5">
                                        👤 Personal
                                    </span>
                                )}
                                {popupNote.category && (
                                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold capitalize ${popupNote.category === 'celebration' ? 'bg-pink-100 text-pink-800' :
                                        popupNote.category === 'event' ? 'bg-purple-100 text-purple-800' :
                                            popupNote.category === 'notification' ? 'bg-amber-100 text-amber-800' :
                                                'bg-teal-100 text-teal-800'
                                        }`}>
                                        {popupNote.category}
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Body */}
                        <div className="flex-1 overflow-y-auto p-6 space-y-4">
                            <h3 className="text-lg font-extrabold text-gray-900">{popupNote.title}</h3>
                            <div
                                className="text-gray-700 leading-relaxed break-words prose prose-sm max-w-none border-b border-gray-100 pb-4"
                                dangerouslySetInnerHTML={{ __html: popupNote.description }}
                            />

                            {popupNote.attachment_path && (
                                <div className="p-3 bg-gray-50 rounded-xl border border-gray-200 flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <span className="text-xs text-gray-600 truncate max-w-[280px]">
                                            {popupNote.attachment_name || 'Attachment'}
                                        </span>
                                    </div>
                                    <a
                                        href={`${process.env.REACT_APP_IMAGEURL || ''}/${popupNote.attachment_path}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-xs text-main hover:text-mainHover font-bold flex items-center gap-1 hover:underline"
                                    >
                                        <FiDownload className="inline" /> Download
                                    </a>
                                </div>
                            )}


                            <div className="text-[10px] text-gray-400 flex justify-between items-center bg-gray-50 p-2.5 rounded-lg border border-gray-100">
                                <span>Author: <strong className="text-gray-600">{popupNote.author_name || 'HR Department'}</strong></span>
                                <span>Posted: <strong className="text-gray-600">{new Date(popupNote.created_at).toLocaleString('en-GB')}</strong></span>
                            </div>
                        </div>

                        {/* Footer / Acknowledge buttons */}
                        <div className="px-6 py-4 border-t border-gray-200 flex justify-end items-center bg-gray-50">
                            {popupAckSuccess ? (
                                <div className="w-full text-center text-green-700 font-extrabold flex items-center justify-center gap-1 text-sm bg-green-50 py-2 rounded-lg border border-green-200">
                                    ✓ Acknowledged Successfully
                                </div>
                            ) : (
                                <>
                                    {parseInt(popupNote.require_acknowledgement) === 1 && popupNote.read_status !== 'Acknowledged' && !isHROrAdmin ? (
                                        <button
                                            onClick={handleAcknowledgePopup}
                                            className="px-5 py-2 bg-main hover:bg-mainHover text-white font-extrabold rounded-lg transition text-xs flex items-center gap-1"
                                        >
                                            ✓ Acknowledge
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => {
                                                setShowPopup(false);
                                                setPopupNote(null);
                                                checkActiveNotes();
                                            }}
                                            className="px-5 py-2 bg-gray-700 hover:bg-gray-800 text-white font-bold rounded-lg transition text-xs"
                                        >
                                            Close
                                        </button>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {selectedFlashNote && (
                <div className="fixed inset-0 bg-black/60 z-[999] flex items-center justify-center p-4 animate-in fade-in duration-200">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-[650px] overflow-hidden text-sm flex flex-col max-h-[85vh] animate-in zoom-in-95 duration-200">

                        {/* Header */}
                        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
                            <span className="flex items-center gap-2 font-bold text-gray-800 text-base">
                                📢 {selectedFlashNote.category === 'celebration' ? '🎉 Celebration' : '📅 Event Details'}
                            </span>
                            <div className="flex items-center gap-1.5">
                                <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${selectedFlashNote.priority === 'Critical'
                                    ? 'bg-red-100 text-red-800'
                                    : (selectedFlashNote.priority === 'Important' ? 'bg-orange-100 text-orange-800' : 'bg-blue-100 text-blue-800')
                                    }`}>
                                    {selectedFlashNote.priority}
                                </span>
                                {selectedFlashNote.category && (
                                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold capitalize ${selectedFlashNote.category === 'celebration' ? 'bg-pink-100 text-pink-800' :
                                        selectedFlashNote.category === 'event' ? 'bg-purple-100 text-purple-800' :
                                            selectedFlashNote.category === 'notification' ? 'bg-amber-100 text-amber-800' :
                                                'bg-teal-100 text-teal-800'
                                        }`}>
                                        {selectedFlashNote.category}
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Body */}
                        <div className="flex-1 overflow-y-auto p-6 space-y-4">
                            <h3 className="text-lg font-extrabold text-gray-900">{selectedFlashNote.title}</h3>
                            <div
                                className="text-gray-700 leading-relaxed break-words prose prose-sm max-w-none border-b border-gray-100 pb-4"
                                dangerouslySetInnerHTML={{ __html: selectedFlashNote.description }}
                            />

                            {selectedFlashNote.attachment_path && (
                                <div className="p-3 bg-gray-50 rounded-xl border border-gray-200 flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                        <span className="text-xs text-gray-600 truncate max-w-[280px]">
                                            {selectedFlashNote.attachment_name || 'Attachment'}
                                        </span>
                                    </div>
                                    <a
                                        href={`${process.env.REACT_APP_IMAGEURL || ''}/${selectedFlashNote.attachment_path}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-xs text-main hover:text-mainHover font-bold flex items-center gap-1 hover:underline"
                                    >
                                        <FiDownload className="inline" /> Download
                                    </a>
                                </div>
                            )}

                            <div className="text-[10px] text-gray-400 flex justify-between items-center bg-gray-50 p-2.5 rounded-lg border border-gray-100">
                                <span>Author: <strong className="text-gray-600">{selectedFlashNote.author_name || 'HR Department'}</strong></span>
                                <span>Posted: <strong className="text-gray-600">{new Date(selectedFlashNote.created_at).toLocaleString('en-GB')}</strong></span>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="px-6 py-4 border-t border-gray-200 flex justify-end items-center bg-gray-50">
                            {popupAckSuccess ? (
                                <div className="w-full text-center text-green-700 font-extrabold flex items-center justify-center gap-1 text-sm bg-green-50 py-2 rounded-lg border border-green-200">
                                    ✓ Acknowledged Successfully
                                </div>
                            ) : (
                                <>
                                    {parseInt(selectedFlashNote.require_acknowledgement) === 1 && selectedFlashNote.read_status !== 'Acknowledged' && !isHROrAdmin ? (
                                        <button
                                            onClick={async () => {
                                                try {
                                                    const res = await api.post('/hrms/notes/acknowledge', {
                                                        note_id: selectedFlashNote.id,
                                                        employee_reply: ''
                                                    });
                                                    if (res.data.status) {
                                                        setPopupAckSuccess(true);
                                                        toast.success('Note acknowledged successfully');
                                                        setTimeout(() => {
                                                            setSelectedFlashNote(null);
                                                            setPopupAckSuccess(false);
                                                            checkActiveNotes();
                                                        }, 1500);
                                                    }
                                                } catch (e) {
                                                    console.error('Flash note acknowledge error:', e);
                                                    toast.error('Failed to acknowledge note');
                                                }
                                            }}
                                            className="px-5 py-2 bg-main hover:bg-mainHover text-white font-extrabold rounded-lg transition text-xs flex items-center gap-1"
                                        >
                                            ✓ Acknowledge
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => {
                                                setSelectedFlashNote(null);
                                            }}
                                            className="px-5 py-2 bg-gray-700 hover:bg-gray-800 text-white font-bold rounded-lg transition text-xs"
                                        >
                                            Close
                                        </button>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ===== LMS Test Assignment Popup — fully independent of HR Notes ===== */}
            {showLmsPopup && currentLmsNotif && isLmsNotifLive(currentLmsNotif) && (
                Number(currentLmsNotif.popup_enabled) === 1 ? (
                    /* Custom popup_enabled notification — uses the unified AssessmentPopup design */
                    <AssessmentPopup
                        isOpen={true}
                        type="warning"
                        title={currentLmsNotif.popup_title || `New Test Assigned: ${currentLmsNotif.test_name}`}
                        message={`${currentLmsNotif.popup_message || `You have been assigned a new LMS test: ${currentLmsNotif.test_name}. Please complete it as scheduled.`}${currentLmsNotif.start_time && currentLmsNotif.end_time
                                ? ` Test Timing: ${formatTime(currentLmsNotif.start_time)} - ${formatTime(currentLmsNotif.end_time)}.`
                                : ''
                            }`}
                        confirmText="Take Test"
                        showCancel={false}
                        showCloseButton={true}
                        closeOnBackdrop={false}
                        onConfirm={() => handleTakeTest(currentLmsNotif)}
                        onCancel={dismissLmsPopup}
                        onBackdropClick={dismissLmsPopup}
                    />
                ) : (
                    /* Standard assignment popup — existing detailed view */
                    <div className="fixed inset-0 bg-black/60 z-[1000] flex items-center justify-center p-4">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-[650px] overflow-hidden text-sm flex flex-col max-h-[85vh]">

                            {/* Header — mirrors HR Announcement style */}
                            <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
                                <span className="flex items-center gap-2 font-bold text-gray-800 text-base">
                                    🎓 LMS Assignment
                                </span>
                                <div className="flex items-center gap-1.5">
                                    <span className="bg-blue-100 text-blue-800 px-2.5 py-0.5 rounded-full text-xs font-bold">
                                        New Test
                                    </span>
                                    <span className="bg-indigo-100 text-indigo-800 px-2.5 py-0.5 rounded-full text-xs font-bold flex items-center gap-0.5">
                                        👤 Personal
                                    </span>
                                    <span className="bg-amber-100 text-amber-800 px-2.5 py-0.5 rounded-full text-xs font-bold capitalize">
                                        notification
                                    </span>
                                    {lmsPopupQueue.length > 1 && (
                                        <span className="bg-gray-200 text-gray-600 px-2.5 py-0.5 rounded-full text-xs font-bold">
                                            {lmsPopupQueue.findIndex((n) => String(n.id) === String(currentLmsNotif.id)) + 1} / {lmsPopupQueue.length}
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* Body */}
                            <div className="flex-1 overflow-y-auto p-6 space-y-4">
                                <h3 className="text-lg font-extrabold text-gray-900">
                                    New Test Assigned: {currentLmsNotif.test_name}
                                </h3>
                                <div className="text-gray-700 leading-relaxed break-words prose prose-sm max-w-none border-b border-gray-100 pb-4">
                                    <p>You have been assigned a new LMS test: <strong>{currentLmsNotif.test_name}</strong>.</p>
                                    {currentLmsNotif.batch_name && (
                                        <p>Batch Name: {currentLmsNotif.batch_name}</p>
                                    )}
                                    {currentLmsNotif.scheduled_date && currentLmsNotif.scheduled_date !== '0000-00-00' && (
                                        <p>Scheduled Date: {new Date(currentLmsNotif.scheduled_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</p>
                                    )}
                                    {currentLmsNotif.start_time && currentLmsNotif.end_time && (
                                        <p>Test Timing: <strong>{formatTime(currentLmsNotif.start_time)} - {formatTime(currentLmsNotif.end_time)}</strong></p>
                                    )}
                                    <p>Please complete it as scheduled.</p>
                                </div>

                                <div className="text-[10px] text-gray-400 flex justify-between items-center bg-gray-50 p-2.5 rounded-lg border border-gray-100">
                                    <span>Source: <strong className="text-gray-600">LMS Module</strong></span>
                                    <span>Assigned: <strong className="text-gray-600">
                                        {currentLmsNotif.created_at
                                            ? new Date(currentLmsNotif.created_at).toLocaleString('en-GB')
                                            : ''}
                                    </strong></span>
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="px-6 py-4 border-t border-gray-200 flex justify-end items-center bg-gray-50">
                                <button
                                    onClick={() => handleTakeTest(currentLmsNotif)}
                                    className="px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg transition text-xs"
                                >
                                    Take Test
                                </button>
                            </div>
                        </div>
                    </div>
                )
            )}
        </Layout>
    );
}

// ==========================================
// Sub-Component: Dashboard Overview
// ==========================================
function DashboardOverview({
    user,
    isHROrAdmin,
    userId,
    roleId,
    setActiveTab,
    lmsNotifications = [],
    allLmsTests = [],
    refreshLmsNotifications,
    handleTakeTest,
    formatTime
}) {
    const designationId = parseInt(user?.designation_id || 0);
    const isVerticalHead = [26, 42, 43, 24].includes(designationId) || userId == 111;
    const hasLeadTrendsAccess = isHROrAdmin || isVerticalHead;

    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const getTestStatus = (test) => {
        if (!test) return 'expired';
        if (test.submission_status === 'COMPLETED') return 'completed';
        if (!test.scheduled_date || !test.start_time || !test.end_time) return 'live';
        const now = new Date();
        const startDateTime = new Date(`${test.scheduled_date}T${test.start_time}`);
        const endDateTime = new Date(`${test.scheduled_date}T${test.end_time}`);
        if (now < startDateTime) {
            return 'upcoming';
        } else if (now >= startDateTime && now <= endDateTime) {
            return 'live';
        } else {
            return 'expired'; // Past scheduled window
        }
    };

    // Calendar State
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [calendarYear, setCalendarYear] = useState(new Date().getFullYear());
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showEventModal, setShowEventModal] = useState(false);
    const [todaysOnCall, setTodaysOnCall] = useState([]);
    const [eventFormData, setEventFormData] = useState({
        event_type: 'Event',
        event_title: '',
        event_description: '',
        from_date: '',
        to_date: '',
        primary_persons: [],
        secondary_persons: []
    });
    const [employeesList, setEmployeesList] = useState([]);
    const [dateEvents, setDateEvents] = useState([]);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [eventToDelete, setEventToDelete] = useState(null);
    const [editingEventId, setEditingEventId] = useState(null);
    // My missing out punch dates (employee-only, YYYY-MM-DD[])
    const [myMissingOutDates, setMyMissingOutDates] = useState([]);

    // GitLab Stats
    const [gitlabStats, setGitlabStats] = useState(null);


    // Chart State
    const [ticketYear, setTicketYear] = useState(new Date().getFullYear());
    const [analyticsYear, setAnalyticsYear] = useState(new Date().getFullYear());

    // Admin VH Filter for Analytics
    const [selectedVH, setSelectedVH] = useState('');
    const [verticalHeads, setVerticalHeads] = useState([]);

    useEffect(() => {
        if (isHROrAdmin) {
            const fetchVH = async () => {
                try {
                    const res = await api.get('/ticket/get_vertical_heads');
                    if (res.data.status) {
                        setVerticalHeads(res.data.data);
                    }
                } catch (e) {
                    console.error('Error fetching vertical heads:', e);
                }
            };
            fetchVH();
        }
    }, [isHROrAdmin]);

    const [chartData, setChartData] = useState({ categories: [], series: [] });
    // Generate Year Options (Last 5 years)
    const yearOptions = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);

    // Leave Analytics State
    const [leaveYear, setLeaveYear] = useState(new Date().getFullYear());
    const [leaveMonth, setLeaveMonth] = useState((new Date().getMonth() + 1).toString());
    const [leaveAnalytics, setLeaveAnalytics] = useState(null);
    const [leaveLoading, setLeaveLoading] = useState(false);

    // Leave Type Chart State
    const [leaveTypeYear, setLeaveTypeYear] = useState(new Date().getFullYear());
    const [leaveTypeData, setLeaveTypeData] = useState({ categories: [], series: [] });
    const [leaveTypeLoading, setLeaveTypeLoading] = useState(false);

    // Summary Drill-down State
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [summaryCategory, setSummaryCategory] = useState({ id: '', label: '' });
    const [summaryDetails, setSummaryDetails] = useState([]);
    const [summaryDetailLoading, setSummaryDetailLoading] = useState(false);

    const handleSummaryClick = async (id, label) => {
        setSummaryCategory({ id, label });
        setSummaryDetailLoading(true);
        setShowSummaryModal(true);
        setSummaryDetails([]); // Clear previous
        try {
            const res = await api.get('/hrms/summary-details', {
                params: {
                    user_id: userId,
                    year: leaveYear,
                    month: leaveMonth === 'all' ? '' : leaveMonth,
                    category: id
                }
            });
            if (res.data.status) {
                setSummaryDetails(res.data.data);
            }
        } catch (error) {
            console.error('Error fetching summary details:', error);
            toast.error('Failed to load details');
        } finally {
            setSummaryDetailLoading(false);
        }
    };

    const handleAccountSummaryExport = async () => {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Account Summary');

            // 1. Title & Metadata
            worksheet.mergeCells('A1:B1');
            const titleCell = worksheet.getCell('A1');
            titleCell.value = 'Employee Account Summary';
            titleCell.font = { name: 'Arial', size: 16, bold: true, color: { argb: 'FF047857' } };
            titleCell.alignment = { vertical: 'middle', horizontal: 'center' };

            worksheet.mergeCells('A2:B2');
            const periodCell = worksheet.getCell('A2');
            const monthName = leaveMonth === 'all' ? 'All Months' : new Date(2022, parseInt(leaveMonth) - 1).toLocaleString('default', { month: 'long' });
            periodCell.value = `Year: ${leaveYear} | Period: ${monthName}`;
            periodCell.alignment = { horizontal: 'center' };
            periodCell.font = { italic: true };

            worksheet.addRow([]); // Spacer

            // 2. Headers
            const headerRow = worksheet.addRow(['Metric / Category', 'Value']);
            headerRow.eachCell((cell) => {
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF047857' } };
                cell.alignment = { horizontal: 'center' };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });

            // 3. Data from stats
            const stats = leaveAnalytics?.stats || {};
            const dataRows = [
                ['Total Leave Quota', stats.total_leaves || 0],
                ['Remaining Balance', stats.current_balance || 0],
                ['Taken (Approved)', stats.taken || 0],
                ['Unscheduled (Emergency)', stats.unscheduled || 0],
                ['Late Punches', stats.total_late || 0],
                ['Pending Requests', stats.request || 0],
                ['Loss of Pay Days', stats.loss_of_pay || 0],
                ['Paid Permission Hours', stats.paid_permission || 0],
                ['Days Absent', stats.absent || 0],
                ['Total Worked Count', stats.worked_days || 0]
            ];

            dataRows.forEach(row => {
                const r = worksheet.addRow(row);
                r.getCell(2).alignment = { horizontal: 'center' };
                r.eachCell(cell => {
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });
            });

            worksheet.columns = [
                { key: 'metric', width: 35 },
                { key: 'value', width: 20 }
            ];

            // 4. Save file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `Account_Summary_${leaveYear}_${leaveMonth}.xlsx`);
            toast.success("Excel exported successfully");
        } catch (error) {
            console.error('Export Error:', error);
            toast.error('Failed to export data');
        }
    };

    const fetchLeaveTypeData = async () => {
        try {
            setLeaveTypeLoading(true);
            const res = await api.get('/hrms/monthwise-leave-types', {
                params: { year: leaveTypeYear }
            });
            if (res.data.status) {
                setLeaveTypeData(res.data.data);
            }
        } catch (error) {
            console.error('Error fetching leave type data:', error);
        } finally {
            setLeaveTypeLoading(false);
        }
    };

    useEffect(() => {
        if (userId && roleId) {
            fetchLeaveTypeData();
        }
    }, [userId, roleId, leaveTypeYear]);


    const fetchLeaveAnalytics = async () => {
        try {
            setLeaveLoading(true);
            const res = await api.get('/hrms/leave-analytics', {
                params: {
                    user_id: userId,
                    year: leaveYear,
                    month: leaveMonth === 'all' ? '' : leaveMonth
                }
            });
            if (res.data.status) {
                setLeaveAnalytics(res.data.data);
            }
        } catch (error) {
            console.error('Error fetching leave analytics:', error);
        } finally {
            setLeaveLoading(false);
        }
    };

    useEffect(() => {
        if (userId && !isHROrAdmin) {
            fetchLeaveAnalytics();
        }
    }, [userId, leaveYear, leaveMonth]);

    // 1. Fetch Stats
    useEffect(() => {
        const fetchDashboardStats = async () => {
            try {
                setLoading(true);
                const response = await api.get('/hrms/dashboard-stats', {
                    params: { user_id: userId, role_id: roleId }
                });
                if (response.data.status) {
                    setStats(prev => ({ ...prev, ...response.data.data }));
                }
            } catch (error) {
                console.error('Error fetching dashboard stats:', error);
                toast.error('Failed to load dashboard statistics');
            } finally {
                setLoading(false);
            }
        };
        if (userId && roleId) fetchDashboardStats();

        const fetchEmployeesList = async () => {
            if (!isHROrAdmin && !isVerticalHead) return;
            try {
                const res = await api.get('/hrms/employee-list');
                if (res.data.status) {
                    setEmployeesList(res.data.data.map(emp => ({
                        value: emp.user_id,
                        label: `${emp.first_name} ${emp.last_name} (${emp.designation})`
                    })));
                }
            } catch (error) { console.error('Error fetching employees:', error); }
        };
        fetchEmployeesList();
    }, [userId, roleId]);

    useEffect(() => {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        const todayStr = today.toISOString().split('T')[0];
        const tomorrowStr = tomorrow.toISOString().split('T')[0];

        const relevantOnCall = (calendarEvents || []).filter(e => {
            const isOnCall = (e.event_type || '').trim() === 'On Call';
            if (!isOnCall) return false;

            const from = e.from_date || '';
            const to = e.to_date || '';

            const isToday = todayStr >= from && todayStr <= to;
            const isTomorrow = tomorrowStr >= from && tomorrowStr <= to;

            return isToday || isTomorrow;
        }).map(e => {
            const from = e.from_date || '';
            const to = e.to_date || '';
            const isToday = todayStr >= from && todayStr <= to;
            return { ...e, isToday };
        });
        setTodaysOnCall(relevantOnCall);
    }, [calendarEvents]);

    // 2. Fetch Calendar Events
    const fetchCalendarEvents = async () => {
        try {
            const response = await api.get('/hrms/calendar-events', {
                params: { month: currentMonth + 1, year: calendarYear }
            });
            if (response.data.status) {
                setCalendarEvents(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching calendar events:', error);
        }
    };

    // 2b. Fetch MY missing out punch dates via existing endpoint (employees only)
    const fetchMyMissingOutPunch = async () => {
        if (isHROrAdmin) return;
        try {
            // Build from/to for the full calendar month
            const mm = String(currentMonth + 1).padStart(2, '0');
            const from = `${calendarYear}-${mm}-01`;
            const lastDay = new Date(calendarYear, currentMonth + 1, 0).getDate();
            const to = `${calendarYear}-${mm}-${String(lastDay).padStart(2, '0')}`;

            const res = await api.get('/hrms/missing-out-punch', { params: { from, to } });
            if (res.data.status && res.data.data?.length) {
                // API returns dates as 'd/m/Y' — convert to 'YYYY-MM-DD' for calendar matching
                const allDates = res.data.data.flatMap(emp =>
                    (emp.dates || []).map(d => {
                        const [day, mon, yr] = d.split('/');
                        return `${yr}-${mon}-${day}`;
                    })
                );
                setMyMissingOutDates([...new Set(allDates)]);
            } else {
                setMyMissingOutDates([]);
            }
        } catch (error) {
            console.error('Error fetching missing out punch:', error);
        }
    };

    useEffect(() => {
        fetchCalendarEvents();
        fetchMyMissingOutPunch();
    }, [currentMonth, calendarYear]);


    // 3. Fetch Chart Data & Analytics
    useEffect(() => {
        const processChartData = (res) => {
            if (res.data.data?.data) {
                const tickets = res.data.data.data;
                const months = Object.keys(tickets);
                const ticketArray = Object.values(tickets);
                const statusColors = {
                    'Tickets': '#10b981',
                    'Late Punches': '#f59e0b',
                    'Leaves Taken': '#ef4444',
                    'PENDING VERIFICATION & CLOSURE': '#1f77b4',
                    'IN PROCESS': '#ff7f0e',
                    'REOPEN': '#d62728',
                    'CLOSED': '#10b981',
                    'NEW': '#facc15',
                    'TESTING': '#20c997',
                    'TESTING APPROVED': '#0ea5e9',
                    'TESTING REJECTED': '#f43f5e',
                    'PENDING CUSTOMER VERIFICATION & CONFIRMATION': '#8b5cf6'
                };
                const statuses = [...new Set(ticketArray.flatMap((obj) => Object.keys(obj).filter((k) => k !== 'month' && k !== 'year')))];
                const seriesTemp = statuses.map((status) => ({
                    name: status,
                    data: months.map((m) => {
                        const statusData = tickets[m] && tickets[m][status];
                        if (!statusData) return 0;
                        return Object.values(statusData || {}).reduce((sum, v) => sum + (v.count ?? 0), 0);
                    }),
                    stack: 'Ticket',
                    color: statusColors[status]
                }));
                setChartData({ categories: months, series: seriesTemp });
            } else {
                setChartData({ categories: [], series: [] });
            }
        };

        const fetchOverallChartData = async () => {
            try {
                const res = await api.get('/ticket/chartData', {
                    params: { user_id: userId, selectedYears: [ticketYear] }
                });
                processChartData(res);
            } catch (err) {
                console.error('Error fetching chart data:', err);
            }
        };

        const fetchEmployeePerformance = async () => {
            try {
                const res = await api.get('/ticket/chartData', {
                    params: { user_id: userId, selectedYears: [ticketYear] }
                });
                processChartData(res);
            } catch (error) {
                console.error('Error fetching employee performance:', error);
            }
        };

        if (userId && roleId) {
            if (isHROrAdmin) fetchOverallChartData();
            else fetchEmployeePerformance();
        }
    }, [userId, roleId, isHROrAdmin, ticketYear]);

    // 4. Fetch Analytics (Isolated)
    useEffect(() => {
        const fetchAnalytics = async () => {
            try {
                // Clear previous data to indicate loading/change
                setStats(prev => ({
                    ...prev,
                    monthly_overall: Array(12).fill(0),
                    monthly_overall_internal: Array(12).fill(0),
                    monthly_overall_external: Array(12).fill(0),
                    monthly_my: Array(12).fill(0),
                    monthly_vh: Array(12).fill(0)
                }));

                const res = await api.get('/hrms/analytics', { params: { year: analyticsYear, vh_id: selectedVH || '' } });
                if (res.data.status) {
                    const { overall_avg, my_avg, monthly_overall, monthly_overall_internal, monthly_overall_external, monthly_my, monthly_vh } = res.data.data;
                    setStats(prev => ({
                        ...prev, overall_avg, my_avg, monthly_overall, monthly_overall_internal, monthly_overall_external, monthly_my, monthly_vh
                    }));
                }
            } catch (error) {
                console.error('Error fetching analytics:', error);
            }
        };

        if (userId && roleId) {
            fetchAnalytics();
        }
    }, [userId, roleId, analyticsYear, selectedVH]);


    // 5. Fetch GitLab Stats (Removed - Moved to GitActivity)

    // Calendar Helpers
    const formatDateForAPI = (date) => {
        const d = new Date(calendarYear, currentMonth, date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatDateDisplay = (date) => {
        const d = new Date(calendarYear, currentMonth, date);
        return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();
    const getFirstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();
    const isSunday = (date) => {
        const d = new Date(calendarYear, currentMonth, date);
        if (d.getDay() !== 0) return false;
        const dateStr = formatDateForAPI(date);
        return calendarEvents.some(event => event.event_date === dateStr && event.event_type === 'Holiday');
    };
    const getEventsForDate = (date) => {
        const dateStr = formatDateForAPI(date);
        const regularEvents = calendarEvents.filter(event => {
            if (event.event_type === 'On Call' || event.event_type === 'Meeting') {
                return event.from_date && event.to_date
                    ? (dateStr >= event.from_date && dateStr <= event.to_date)
                    : (event.event_date === dateStr);
            }
            return event.event_date === dateStr;
        });

        let combinedEvents = [...regularEvents];

        // Add Missing Out Punch if applicable
        if (!isHROrAdmin && myMissingOutDates.includes(dateStr)) {
            combinedEvents.push({
                id: `mop-${dateStr}`,
                event_date: dateStr,
                event_type: 'Missing',
                event_title: 'Missing Out Punch',
                event_description: 'You did not punch out on this day.',
                isSynthetic: true,
            });
        }

        // Add Assigned LMS Tests
        if (Array.isArray(allLmsTests)) {
            allLmsTests.forEach(test => {
                const assignedDate = test.scheduled_date || (test.created_at ? getAssignedDateOnly(test.created_at) : '');
                if (assignedDate === dateStr) {
                    const status = getTestStatus(test);
                    let eventType = 'Upcoming Test';
                    if (status === 'live') {
                        eventType = 'Live Test';
                    } else if (status === 'completed') {
                        eventType = 'Completed Test';
                    } else if (status === 'expired') {
                        eventType = 'Expired Test';
                    }
                    const formattedDate = test.scheduled_date && test.scheduled_date !== '0000-00-00'
                        ? new Date(test.scheduled_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
                        : '';
                    const formattedTime = test.start_time && test.end_time
                        ? `${formatTime(test.start_time)} - ${formatTime(test.end_time)}`
                        : '';
                    combinedEvents.push({
                        id: `lms-${test.id}`,
                        event_date: dateStr,
                        event_type: eventType,
                        event_title: test.test_name,
                        event_description: `Test Date: ${formattedDate} | Test Time: ${formattedTime}`,
                        isSynthetic: true,
                        isLmsTest: true,
                        testData: test
                    });
                }
            });
        }

        // Sort: On Call first, then Holiday/Floating Holiday, then everything else
        return combinedEvents.sort((a, b) => {
            const priority = { 'On Call': 0, 'Holiday': 1, 'Floating Holiday': 2 };
            const pA = priority[a.event_type] ?? 10;
            const pB = priority[b.event_type] ?? 10;
            if (pA !== pB) return pA - pB;
            return 0;
        });
    };

    const handleDateClick = (date) => {
        setSelectedDate(date);
        const dateStr = formatDateForAPI(date);

        // Use the common helper to get all events (including synthetic ones) for this date
        const events = getEventsForDate(date);
        setDateEvents(events);

        setShowEventModal(true);
        setEventFormData({
            event_type: isVerticalHead && !isHROrAdmin ? 'On Call' : 'Event',
            event_title: '',
            event_description: '',
            from_date: dateStr,
            to_date: dateStr,
            primary_persons: [],
            secondary_persons: []
        });
        setEditingEventId(null);
    };

    const handleEditEvent = (event) => {
        setEditingEventId(event.id);
        setEventFormData({
            event_type: event.event_type,
            event_title: event.event_title,
            event_description: event.event_description || '',
            from_date: event.from_date || event.event_date,
            to_date: event.to_date || event.event_date,
            primary_persons: event.primary_persons ? event.primary_persons.split(',').map(id => employeesList.find(e => e.value == id)).filter(Boolean) : [],
            secondary_persons: event.secondary_persons ? event.secondary_persons.split(',').map(id => employeesList.find(e => e.value == id)).filter(Boolean) : []
        });
    };

    const handleSaveEvent = async () => {
        if (!eventFormData.event_title.trim()) { toast.error('Event title is required'); return; }
        try {
            const url = editingEventId ? '/hrms/update-event' : '/hrms/create-event';
            const payload = {
                user_id: userId, role_id: roleId,
                event_date: formatDateForAPI(selectedDate),
                ...eventFormData,
                primary_persons: (eventFormData.primary_persons || []).map(p => p.value),
                secondary_persons: (eventFormData.secondary_persons || []).map(p => p.value)
            };
            if (editingEventId) payload.event_id = editingEventId;
            const response = await api.post(url, payload);
            if (response.data.status) {
                toast.success(editingEventId ? 'Event updated successfully' : 'Event created successfully');
                setShowEventModal(false);
                fetchCalendarEvents();
                setEventFormData({
                    event_type: 'Event',
                    event_title: '',
                    event_description: '',
                    from_date: '',
                    to_date: '',
                    primary_persons: [],
                    secondary_persons: []
                });
                setEditingEventId(null);
            }
        } catch (error) {
            console.error('Error saving event:', error);
            toast.error(error.response?.data?.message || 'Failed to save event');
        }
    };

    const handleDeleteEvent = (eventId) => {
        setEventToDelete(eventId);
        setShowDeleteConfirm(true);
    };

    const confirmDeleteEvent = async () => {
        if (!eventToDelete) return;
        try {
            const response = await api.post('/hrms/delete-event', { user_id: userId, role_id: roleId, event_id: eventToDelete });
            if (response.data.status) {
                toast.success('Event deleted successfully');
                fetchCalendarEvents();
                setDateEvents(dateEvents.filter(e => e.id !== eventToDelete));
                setShowDeleteConfirm(false);
                setEventToDelete(null);
            }
        } catch (error) {
            console.error('Error deleting event:', error);
            toast.error(error.response?.data?.message || 'Failed to delete event');
            setShowDeleteConfirm(false);
        }
    };

    const handlePrevMonth = () => {
        if (currentMonth === 0) { setCurrentMonth(11); setCalendarYear(calendarYear - 1); }
        else { setCurrentMonth(currentMonth - 1); }
    };

    const handleNextMonth = () => {
        if (currentMonth === 11) { setCurrentMonth(0); setCalendarYear(calendarYear + 1); }
        else { setCurrentMonth(currentMonth + 1); }
    };

    const getEventTypeColor = (type) => {
        const t = (type || '').trim();
        const colors = {
            'Holiday': 'bg-green-100 text-green-700 border-green-300',
            'Floating Holiday': 'bg-amber-100 text-amber-800 border-amber-300',
            'Event': 'bg-blue-100 text-blue-700 border-blue-300',
            'Meeting': 'bg-purple-100 text-purple-700 border-purple-300',
            'Deadline': 'bg-red-100 text-red-700 border-red-300',
            'On Call': 'bg-indigo-100 text-indigo-700 border-indigo-300',
            'Missing': 'bg-red-200 text-red-800 border-red-500',
            'Live Test': 'bg-teal-100 text-teal-800 border-teal-300',
            'Upcoming Test': 'bg-amber-100 text-amber-800 border-amber-300',
            'Completed Test': 'bg-emerald-100 text-emerald-800 border-emerald-300',
            'Expired Test': 'bg-slate-100 text-slate-700 border-slate-300'
        };
        return colors[t] || 'bg-gray-100 text-gray-700 border-gray-300';
    };


    const renderCalendar = () => {
        const daysInMonth = getDaysInMonth(currentMonth, calendarYear);
        const firstDay = getFirstDayOfMonth(currentMonth, calendarYear);
        const days = [];
        for (let i = 0; i < firstDay; i++) days.push(<div key={`empty-${i}`} className="calendar-day-cell empty"></div>);
        for (let date = 1; date <= daysInMonth; date++) {
            const events = getEventsForDate(date);
            const sunday = isSunday(date);
            const isOnCall = events.some(e => (e.event_type || '').trim() === 'On Call');

            const today = new Date();
            const isToday = date === today.getDate() &&
                currentMonth === today.getMonth() &&
                calendarYear === today.getFullYear();

            days.push(
                <div key={date} className={`calendar-day-cell ${sunday ? 'sunday' : ''} ${isOnCall ? 'on-call-day' : ''} ${isToday ? 'today' : ''}`} onClick={() => handleDateClick(date)}>
                    <div className="flex justify-between items-center mb-1">
                        <div className="date-number">{date}</div>
                        {isOnCall && (
                            <div className="on-call-indicator animate-pulse" title="On Call Schedule Active">
                                <FiClock className="text-indigo-600 text-[12px]" />
                            </div>
                        )}
                    </div>
                    <div className="events-container">
                        {events.slice(0, 2).map((event, idx) => (
                            <div key={idx} className={`event-badge ${getEventTypeColor(event.event_type)}`}><span className="event-dot"></span><span className="event-text">{event.event_title}</span></div>
                        ))}
                        {events.length > 2 && <div className="event-more">+{events.length - 2} more</div>}
                    </div>
                </div>
            );
        }
        return days;
    };

    const allMonthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const nowLimit = new Date();
    const currentYearLimit = nowLimit.getFullYear();
    const currentMonthIdxLimit = nowLimit.getMonth();
    const monthLimit = analyticsYear === currentYearLimit ? currentMonthIdxLimit + 1 : 12;
    const chartCategories = allMonthsShort.slice(0, monthLimit);

    return (
        <div className="space-y-6">
            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
                {isHROrAdmin ? (
                    <>
                        <StatCard icon={<FiUsers className="text-3xl" />} title="Active Employees" value={stats.activeEmployees || 0} color="blue" loading={loading} />
                        <StatCard icon={<FiUserCheck className="text-3xl" />} title="Total Clients" value={stats.totalClients || 0} color="green" loading={loading} />
                        <StatCard icon={<FiClock className="text-3xl" />} title="Total Tickets" value={stats.totalTickets || 0} color="purple" loading={loading} />
                        <StatCard icon={<FiCheckCircle className="text-3xl" />} title="Completed This Month" value={stats.completedTicketsThisMonth || 0} color="amber" loading={loading} />
                    </>
                ) : (
                    <>
                        {/* <StatCard icon={<FiClock className="text-3xl" />} title="Assigned Tickets" value={stats.assignedTickets || 0} color="blue" loading={loading} />
                        <StatCard icon={<FiUsers className="text-3xl" />} title="Pending Tickets" value={stats.pendingTickets || 0} color="amber" loading={loading} />
                        <StatCard icon={<FiRotateCcw className="text-3xl" />} title="Reopened Tickets" value={stats.reopenedTickets || 0} color="purple" loading={loading} />
                        <StatCard icon={<FiCheckCircle className="text-3xl" />} title="Completed This Month" value={stats.completedTicketsThisMonth || 0} color="green" loading={loading} /> */}
                    </>
                )}
            </div>
            {/* GitLab Activity Section Removed */}

            {/* Chart and Calendar Row */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
                <div className="space-y-6">
                    <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-xl font-bold text-gray-800">{isHROrAdmin ? 'Ticket Analysis - Overall' : 'My Performance'}</h3>
                            <div className="flex items-center space-x-2">
                                <span className="text-sm text-gray-500">Year:</span>
                                <select
                                    className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-6"
                                    value={ticketYear}
                                    onChange={(e) => setTicketYear(parseInt(e.target.value))}
                                >
                                    {yearOptions.map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        {chartData.series && chartData.series.length > 0 && chartData.categories && chartData.categories.length > 0 ? (
                            <OverallTicketChart collegeName={isHROrAdmin ? "" : "- PERFORMANCE OVERVIEW"} categories={chartData.categories} series={chartData.series} height={460} />
                        ) : (
                            <div className="flex items-center justify-center h-[460px] text-gray-400">
                                <div className="text-center"><FiClock className="text-5xl mx-auto mb-2" /><p>No data available</p></div>
                            </div>
                        )}
                    </div>

                    {/* Duration Chart */}
                    <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-bold text-gray-800">Avg Ticket Handling Time (Hours)</h3>
                            {/* Reuse global year, or allow independent if needed. User asked for year dropdown "top right of chart... for all charts". 
                                 Since they share state, showing it on both indicates it filters both. 
                             */}
                            <div className="flex items-center space-x-2">
                                {/* <span className="text-sm text-gray-500">Year:</span> */}
                                {isHROrAdmin && (
                                    <>
                                        <span className="text-sm text-gray-500">Vertical Head:</span>
                                        <select
                                            className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-6"
                                            value={selectedVH}
                                            onChange={(e) => setSelectedVH(e.target.value)}
                                        >
                                            <option value="">All</option>
                                            {verticalHeads.map(vh => (
                                                <option key={vh.user_id} value={vh.user_id}>{vh.first_name} {vh.last_name}</option>
                                            ))}
                                        </select>
                                    </>
                                )}
                                <span className="text-sm text-gray-500 ml-2">Year:</span>
                                <select
                                    className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-6"
                                    value={analyticsYear}
                                    onChange={(e) => setAnalyticsYear(parseInt(e.target.value))}
                                >
                                    {yearOptions.map(y => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={{
                                exporting: {
                                    enabled: true,
                                    sourceWidth: 1200,
                                    chartOptions: {
                                        chart: { backgroundColor: '#ffffff' }
                                    }
                                },
                                chart: { type: 'spline', height: 450 },
                                title: { text: null },
                                xAxis: {
                                    categories: chartCategories,
                                    crosshair: true,
                                    title: { text: 'Month' }
                                },
                                yAxis: { min: 0, title: { text: 'Avg Hours' } },
                                plotOptions: { spline: { marker: { radius: 4, lineColor: '#666666', lineWidth: 1 }, dataLabels: { enabled: true, format: '{y}', allowOverlap: true, crop: false, overflow: 'justify' } } },
                                tooltip: { shared: true, valueSuffix: ' hrs' },
                                series: isHROrAdmin
                                    ? (selectedVH ?
                                        [
                                            { name: 'Company Avg', data: (stats.monthly_overall || []).slice(0, monthLimit), color: '#6366f1' },
                                            { name: 'Vertical Head Avg', data: (stats.monthly_vh || []).slice(0, monthLimit), color: '#10b981' }
                                        ]
                                        :
                                        [
                                            { name: 'Internal Tickets Avg', data: (stats.monthly_overall_internal || []).slice(0, monthLimit), color: '#3b82f6' },
                                            { name: 'External Tickets Avg', data: (stats.monthly_overall_external || []).slice(0, monthLimit), color: '#ef4444' }
                                        ])
                                    : [
                                        { name: 'Company Avg', data: (stats.monthly_overall || []).slice(0, monthLimit), color: '#6366f1' },
                                        { name: 'My Avg', data: (stats.monthly_my || []).slice(0, monthLimit), color: '#10b981' }
                                    ]
                            }}
                        />
                    </div>
                </div>


                <div className="space-y-6">
                    {/* Office Calendar */}
                    <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition flex flex-col h-[540px]">
                        <div className="p-4 border-b border-gray-200">
                            <div className="flex justify-between items-center">
                                <h3 className="text-lg font-bold text-gray-800">Office Calendar</h3>
                                <div className="flex items-center gap-2">
                                    <div className="flex items-center gap-1">
                                        <select value={currentMonth} onChange={(e) => setCurrentMonth(parseInt(e.target.value))} className="border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 w-24">
                                            {monthNames.map((month, idx) => <option key={idx} value={idx}>{month}</option>)}
                                        </select>
                                        <select value={calendarYear} onChange={(e) => setCalendarYear(parseInt(e.target.value))} className="border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 w-20">
                                            {[2023, 2024, 2025, 2026, 2027].map(year => <option key={year} value={year}>{year}</option>)}
                                        </select>
                                    </div>
                                    <div className="flex gap-1">
                                        <button onClick={handlePrevMonth} className="p-1.5 border border-gray-300 rounded hover:bg-gray-50"><FiChevronLeft size={14} /></button>
                                        <button onClick={handleNextMonth} className="p-1.5 border border-gray-300 rounded hover:bg-gray-50"><FiChevronRight size={14} /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-6 flex-1 flex flex-col min-h-0">
                            {/* Weekday Headers - Fixed */}
                            <div className="grid grid-cols-7 mb-1 flex-shrink-0">
                                <div className="weekday-header">Sun</div><div className="weekday-header">Mon</div><div className="weekday-header">Tue</div>
                                <div className="weekday-header">Wed</div><div className="weekday-header">Thu</div><div className="weekday-header">Fri</div><div className="weekday-header">Sat</div>
                            </div>

                            {/* Calendar Days - Flexible Grid */}
                            <div className="calendar-grid flex-1 min-h-0">
                                {renderCalendar()}
                            </div>
                            <div className="mt-4 pt-4 border-t border-gray-200">
                                <h4 className="text-xs font-semibold text-gray-700 mb-2">Legend</h4>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-green-500"></div><span className="text-[10px] text-gray-600">Holiday</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-blue-500"></div><span className="text-[10px] text-gray-600">Event</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-purple-500"></div><span className="text-[10px] text-gray-600">Meeting</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-red-500"></div><span className="text-[10px] text-gray-600">Deadline</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-indigo-500"></div><span className="text-[10px] text-gray-600">On Call</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-teal-500"></div><span className="text-[10px] text-gray-600">Live Test</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-amber-500"></div><span className="text-[10px] text-gray-600">Upcoming Test</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-emerald-500"></div><span className="text-[10px] text-gray-600">Completed Test</span></div>
                                    <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-slate-400"></div><span className="text-[10px] text-gray-600">Expired Test</span></div>
                                    {!isHROrAdmin && <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-red-800 border border-red-500"></div><span className="text-[10px] text-gray-600">Missing Report</span></div>}
                                    {!isHROrAdmin && <div className="flex items-center gap-2"><div className="w-2.5 h-2.5 rounded-full bg-red-400"></div><span className="text-[10px] text-gray-600">Missing Out Punch</span></div>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Leave Type Chart - Month-wise */}
                    {isHROrAdmin && (
                        <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-lg font-bold text-gray-800">Month-wise Leave Type Analysis</h3>
                                <div className="flex items-center space-x-2">
                                    <span className="text-sm text-gray-500">Year:</span>
                                    <select
                                        className="border border-gray-300 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-6"
                                        value={leaveTypeYear}
                                        onChange={(e) => setLeaveTypeYear(parseInt(e.target.value))}
                                    >
                                        {yearOptions.map(y => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {leaveTypeLoading ? (
                                <div className="flex items-center justify-center h-[450px] text-gray-400">
                                    <div className="text-center"><FiClock className="text-5xl mx-auto mb-2 animate-spin" /><p>Loading...</p></div>
                                </div>
                            ) : leaveTypeData?.series?.length > 0 ? (
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={{
                                        exporting: {
                                            enabled: true,
                                            sourceWidth: 1200,
                                            chartOptions: {
                                                chart: { backgroundColor: '#ffffff' }
                                            }
                                        },
                                        chart: {
                                            type: 'area',
                                            height: 450
                                        },
                                        title: { text: null },
                                        xAxis: {
                                            categories: leaveTypeData.categories,
                                            crosshair: true,
                                            title: { text: 'Month' },
                                            gridLineWidth: 1,
                                            gridLineColor: '#f0f0f0'
                                        },
                                        yAxis: {
                                            min: 0,
                                            title: { text: 'Count' },
                                            allowDecimals: false,
                                            gridLineWidth: 1,
                                            gridLineColor: '#f0f0f0'
                                        },
                                        plotOptions: {
                                            area: {
                                                marker: {
                                                    enabled: true,
                                                    radius: 5,
                                                    lineWidth: 2,
                                                    lineColor: '#ffffff'
                                                },
                                                lineWidth: 2,
                                                states: {
                                                    hover: {
                                                        lineWidth: 3
                                                    }
                                                },
                                                threshold: null
                                            },
                                            line: {
                                                marker: {
                                                    enabled: true,
                                                    radius: 5,
                                                    lineWidth: 2,
                                                    lineColor: '#ffffff'
                                                },
                                                lineWidth: 2,
                                                states: {
                                                    hover: {
                                                        lineWidth: 3
                                                    }
                                                }
                                            }
                                        },
                                        tooltip: {
                                            shared: true,
                                            crosshairs: true,
                                            backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                            borderWidth: 1,
                                            borderColor: '#cccccc',
                                            shadow: true,
                                            useHTML: true,
                                            headerFormat: '<b>{point.key}</b><br/>',
                                            pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
                                        },
                                        legend: {
                                            layout: 'horizontal',
                                            align: 'center',
                                            verticalAlign: 'bottom',
                                            itemStyle: {
                                                fontSize: '12px',
                                                fontWeight: '500'
                                            }
                                        },
                                        series: leaveTypeData.series,
                                        credits: { enabled: false }
                                    }}
                                />
                            ) : (
                                <div className="flex items-center justify-center h-[450px] text-gray-400">
                                    <div className="text-center"><FiClock className="text-5xl mx-auto mb-2" /><p>No data available</p></div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Leave Details - Employee Side */}
                    {!isHROrAdmin && (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-6">
                            {/* Leave Distribution Chart */}
                            <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition">
                                <div className="flex justify-between items-center mb-6">
                                    <h3 className="text-lg font-bold text-gray-800">Leave Details</h3>
                                    <div className="flex gap-1">
                                        <select
                                            value={leaveMonth}
                                            onChange={(e) => setLeaveMonth(e.target.value)}
                                            className="border border-gray-300 rounded px-2 py-1 text-[10px] focus:outline-none focus:ring-2 focus:ring-blue-500 pr-5"
                                        >
                                            <option value="all">All Months</option>
                                            {monthNames.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
                                        </select>
                                        <select
                                            value={leaveYear}
                                            onChange={(e) => setLeaveYear(parseInt(e.target.value))}
                                            className="border border-gray-300 rounded px-2 py-1 text-[10px] focus:outline-none focus:ring-2 focus:ring-blue-500 pr-6"
                                        >
                                            {yearOptions.map(y => <option key={y} value={y}>{y}</option>)}
                                        </select>
                                    </div>
                                </div>
                                {leaveAnalytics?.chart?.length > 0 ? (
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                            exporting: {
                                                enabled: true,
                                                sourceWidth: 1200,
                                                chartOptions: {
                                                    chart: { backgroundColor: '#ffffff' }
                                                }
                                            },
                                            chart: { type: 'pie', height: 350 },
                                            title: { text: null },
                                            plotOptions: {
                                                pie: {
                                                    innerSize: '65%',
                                                    dataLabels: { enabled: false },
                                                    showInLegend: true,
                                                    borderWidth: 0
                                                }
                                            },
                                            tooltip: { pointFormat: '<b>{point.y}</b> days' },
                                            legend: {
                                                layout: 'vertical',
                                                align: 'right',
                                                verticalAlign: 'middle',
                                                itemStyle: { fontSize: '11px', fontWeight: '500' },
                                                labelFormat: '{name}: <b>{y}</b>'
                                            },
                                            series: [{
                                                name: 'Days',
                                                colorByPoint: true,
                                                data: leaveAnalytics.chart
                                            }],
                                            credits: { enabled: false }
                                        }}
                                    />
                                ) : (
                                    <div className="flex items-center justify-center h-[350px] text-gray-400">
                                        <div className="text-center"><FiClock className="text-4xl mx-auto mb-2 text-gray-200" /><p className="text-sm">No activity records</p></div>
                                    </div>
                                )}
                            </div>

                            {/* Leave Summary Stats */}
                            <div className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition flex flex-col">
                                <div className="flex justify-between items-center mb-6">
                                    <h3 className="text-lg font-bold text-gray-800">Leave History</h3>
                                    <button
                                        onClick={handleAccountSummaryExport}
                                        className="flex items-center gap-2 px-4 py-1.5 bg-[#047857] hover:bg-[#064e3b] text-white rounded-full transition-all text-[11px] font-bold shadow-md hover:shadow-lg transform active:scale-95"
                                    >
                                        <FiDownload size={14} />
                                        <span>Export</span>
                                    </button>
                                </div>
                                <div className="grid grid-cols-2 gap-4 flex-1">
                                    <div onClick={() => handleSummaryClick('total_taken', 'Total Taken')} className="p-4 bg-blue-50 rounded-xl flex flex-col justify-center border-2 border-blue-200 cursor-pointer hover:bg-blue-100 transition-all">
                                        <p className="text-xs font-semibold text-blue-600 uppercase tracking-wider mb-1">Total Leave Taken</p>
                                        <p className="text-2xl font-black text-blue-900">{leaveAnalytics?.stats?.total_leave_count || 0}</p>
                                    </div>
                                    <div onClick={() => handleSummaryClick('taken', 'Taken')} className="p-4 bg-green-50 rounded-xl flex flex-col justify-center cursor-pointer hover:bg-green-100 transition-all border border-transparent hover:border-green-200">
                                        <p className="text-xs font-semibold text-green-600 uppercase tracking-wider mb-1">Scheduled Leave Taken</p>
                                        <p className="text-2xl font-black text-green-900">{leaveAnalytics?.stats?.taken || 0}</p>
                                    </div>
                                    <div onClick={() => handleSummaryClick('unscheduled', 'Unscheduled')} className="p-4 bg-orange-50 rounded-xl flex flex-col justify-center cursor-pointer hover:bg-orange-100 transition-all border border-transparent hover:border-orange-200">
                                        <p className="text-xs font-semibold text-orange-600 uppercase tracking-wider mb-1">Unscheduled Leave Taken</p>
                                        <p className="text-2xl font-black text-orange-900">{leaveAnalytics?.stats?.unscheduled || 0}</p>
                                    </div>
                                    <div onClick={() => handleSummaryClick('pending', 'Pending Req.')} className="p-4 bg-purple-50 rounded-xl flex flex-col justify-center cursor-pointer hover:bg-purple-100 transition-all border border-transparent hover:border-purple-200">
                                        <p className="text-xs font-semibold text-purple-600 uppercase tracking-wider mb-1">Pending Req.</p>
                                        <p className="text-2xl font-black text-purple-900">{leaveAnalytics?.stats?.request || 0}</p>
                                    </div>
                                    <div onClick={() => handleSummaryClick('late', 'Late Punches')} className="p-4 bg-emerald-50 rounded-xl flex flex-col justify-center cursor-pointer hover:bg-emerald-100 transition-all border border-transparent hover:border-emerald-200">
                                        <p className="text-xs font-semibold text-emerald-600 uppercase tracking-wider mb-1">Late Punches</p>
                                        <p className="text-2xl font-black text-emerald-900">{leaveAnalytics?.stats?.total_late || 0}</p>
                                    </div>
                                    <div className="p-4 bg-pink-50 rounded-xl flex flex-col justify-center border-2 border-pink-200">
                                        <p className="text-xs font-semibold text-pink-600 uppercase tracking-wider mb-1">Balance</p>
                                        <p className="text-2xl font-black text-pink-900">{leaveAnalytics?.stats?.current_balance || 0}</p>
                                    </div>
                                    <div onClick={() => handleSummaryClick('permission', 'Paid Permission')} className="p-4 bg-cyan-50 rounded-xl flex flex-col justify-center cursor-pointer hover:bg-cyan-100 transition-all border border-transparent hover:border-cyan-200">
                                        <p className="text-xs font-semibold text-cyan-600 uppercase tracking-wider mb-1">Paid Permission</p>
                                        <p className="text-2xl font-black text-cyan-900">{leaveAnalytics?.stats?.paid_permission || 0}h</p>
                                    </div>
                                    <div onClick={() => handleSummaryClick('lop', 'Loss of Pay')} className="p-4 bg-red-50 rounded-xl flex flex-col justify-center cursor-pointer hover:bg-red-100 transition-all border border-transparent hover:border-red-200">
                                        <p className="text-xs font-semibold text-red-600 uppercase tracking-wider mb-1">Loss of Pay</p>
                                        <p className="text-2xl font-black text-red-900">{leaveAnalytics?.stats?.loss_of_pay || 0}</p>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setActiveTab('leaves')}
                                    className="w-full mt-6 py-3 bg-gray-900 text-white rounded-xl text-sm font-black hover:bg-black transition-all shadow-lg hover:shadow-xl active:scale-[0.98]"
                                >
                                    APPLY NEW LEAVE
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Ticket Trends Charts (Role/Designation Restricted) */}
            {hasLeadTrendsAccess && (
                <>
                    <div className="mb-2">
                        <Leadtickettrends />
                    </div>
                    <div className="mb-2">
                        <Verticalhead_wise_tickets />
                    </div>
                </>

            )}

            {isHROrAdmin && (
                <div className="mb-2">
                    <Verticalhead_workload_overview />
                </div>
            )}

            {/* Report Section - HR/Admin Only */}
            {isHROrAdmin && (
                <>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
                        <MissingStatusReport year={calendarYear} month={currentMonth + 1} isHROrAdmin={isHROrAdmin} />
                        <MissingOutPunchChart year={calendarYear} month={currentMonth + 1} isHROrAdmin={isHROrAdmin} />
                    </div>

                    {/* New Company Overview Trends */}
                    <div className="mb-8">
                        <CompanyOverviewCharts />
                    </div>

                    {/* Vertical Heads Overview */}
                    <div className="mb-8">
                        <VerticalHeadsOverview />
                    </div>

                    {/* Employee Ticket Status Overview */}
                    {/* <div className="mb-8">
                        <EmployeeTicketStatusOverview />
                    </div> */}
                </>
            )}

            {/* Event Modal */}
            {showEventModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="p-6 border-b border-gray-200 flex justify-between items-center">
                            <h3 className="text-xl font-bold text-gray-800"><FiCalendar className="inline mr-2" />{formatDateDisplay(selectedDate)}</h3>
                            <button onClick={() => setShowEventModal(false)} className="text-gray-400 hover:text-gray-600"><FiX className="text-2xl" /></button>
                        </div>
                        <div className="p-6">
                            {dateEvents.length > 0 && (
                                <div className="mb-6">
                                    <h4 className="font-semibold text-gray-700 mb-3">Events on this date:</h4>
                                    <div className="space-y-3">
                                        {dateEvents.map((event) => {
                                            const isLms = event.isLmsTest;
                                            const isMeeting = event.id && typeof event.id === 'string' && event.id.startsWith('collab_');
                                            const handleClick = () => {
                                                if (isLms) {
                                                    setShowEventModal(false);
                                                    handleTakeTest(event.testData);
                                                } else if (isMeeting) {
                                                    const meetingId = event.id.replace('collab_', '');
                                                    window.location.href = `/meetings?room=${meetingId}`;
                                                } else if (isHROrAdmin) {
                                                    handleEditEvent(event);
                                                }
                                            };
                                            const pointerClass = (isLms || isMeeting || isHROrAdmin) ? 'cursor-pointer hover:shadow-md transition-shadow' : '';

                                            return (
                                                <div key={event.id} onClick={handleClick} className={`p-4 rounded-lg border-2 ${getEventTypeColor(event.event_type)} ${pointerClass}`}>
                                                    <div className="flex justify-between items-start">
                                                        <div className="flex-1">
                                                            <div className="flex items-center gap-2 mb-2">
                                                                <span className="px-2 py-1 text-xs font-semibold rounded">{event.event_type}</span>
                                                                <h5 className="font-semibold">{event.event_title}</h5>
                                                                {isMeeting && event.status === 'completed' && (
                                                                    <span className="bg-slate-100 text-slate-600 border border-slate-200 px-2 py-0.5 rounded text-[10px] font-bold uppercase ml-2 tracking-wider">Finished</span>
                                                                )}
                                                            </div>

                                                            {event.event_description && <p className="text-sm mt-2">{event.event_description}</p>}
                                                            {event.event_type === 'On Call' && (
                                                                <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3 pt-3 border-t border-indigo-200">
                                                                    <div>
                                                                        <span className="block text-[10px] font-bold uppercase text-indigo-600 mb-1">Primary Level</span>
                                                                        <div className="flex flex-wrap gap-1">
                                                                            {(event.primary_names || []).map((name, i) => (
                                                                                <span key={i} className="px-2 py-0.5 bg-indigo-200 text-indigo-800 rounded text-[10px] font-medium">{name}</span>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <span className="block text-[10px] font-bold uppercase text-indigo-600 mb-1">Secondary Level</span>
                                                                        <div className="flex flex-wrap gap-1">
                                                                            {(event.secondary_names || []).map((name, i) => (
                                                                                <span key={i} className="px-2 py-0.5 bg-indigo-100 text-indigo-700 rounded text-[10px] font-medium">{name}</span>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {isHROrAdmin && !isMeeting && !isLms && <button onClick={(e) => { e.stopPropagation(); handleDeleteEvent(event.id); }} className="ml-4 text-red-500 hover:text-red-700"><FiX /></button>}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            {(isHROrAdmin || isVerticalHead) && (
                                <div>
                                    <h4 className="font-semibold text-gray-700 mb-4">{editingEventId ? 'Edit Event:' : 'Add New Event:'}</h4>
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Event Type</label>
                                            <select
                                                value={eventFormData.event_type}
                                                onChange={(e) => setEventFormData({ ...eventFormData, event_type: e.target.value })}
                                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                            >
                                                {isHROrAdmin && (
                                                    <>
                                                        <option value="Holiday">Holiday</option>
                                                        <option value="Floating Holiday">Floating Holiday</option>
                                                        <option value="Event">Event</option>
                                                        <option value="Meeting">Meeting</option>
                                                        <option value="Deadline">Deadline</option>
                                                    </>
                                                )}
                                                <option value="On Call">On Call</option>
                                            </select>
                                        </div>

                                        {eventFormData.event_type === 'On Call' && (
                                            <motion.div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: 'auto' }}
                                                className="space-y-4 p-4 bg-indigo-50 rounded-xl border border-indigo-100"
                                            >
                                                <div className="grid grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="block text-xs font-bold text-indigo-600 uppercase mb-1">From Date</label>
                                                        <input
                                                            type="date"
                                                            value={eventFormData.from_date}
                                                            onChange={(e) => setEventFormData({ ...eventFormData, from_date: e.target.value })}
                                                            className="w-full border border-indigo-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="block text-xs font-bold text-indigo-600 uppercase mb-1">To Date</label>
                                                        <input
                                                            type="date"
                                                            value={eventFormData.to_date}
                                                            onChange={(e) => setEventFormData({ ...eventFormData, to_date: e.target.value })}
                                                            className="w-full border border-indigo-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-bold text-indigo-600 uppercase mb-1">Primary Persons</label>
                                                    <Select
                                                        isMulti
                                                        options={employeesList}
                                                        value={eventFormData.primary_persons}
                                                        onChange={(val) => setEventFormData({ ...eventFormData, primary_persons: val })}
                                                        className="text-sm"
                                                        placeholder="Select primary persons..."
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-bold text-indigo-600 uppercase mb-1">Secondary Persons</label>
                                                    <Select
                                                        isMulti
                                                        options={employeesList}
                                                        value={eventFormData.secondary_persons}
                                                        onChange={(val) => setEventFormData({ ...eventFormData, secondary_persons: val })}
                                                        className="text-sm"
                                                        placeholder="Select secondary persons..."
                                                    />
                                                </div>
                                            </motion.div>
                                        )}

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Event Title *</label>
                                            <input
                                                type="text"
                                                value={eventFormData.event_title}
                                                onChange={(e) => setEventFormData({ ...eventFormData, event_title: e.target.value })}
                                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                placeholder="Enter event title"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Event Details</label>
                                            <textarea
                                                value={eventFormData.event_description}
                                                onChange={(e) => setEventFormData({ ...eventFormData, event_description: e.target.value })}
                                                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                rows="4"
                                                placeholder="Enter event details..."
                                            ></textarea>
                                        </div>
                                        <div className="flex gap-3 pt-4">
                                            <button onClick={handleSaveEvent} className="flex-1 bg-red-600 hover:bg-red-700 text-white font-medium px-6 py-2.5 rounded-lg transition">
                                                {editingEventId ? 'Update Event' : 'Save Event'}
                                            </button>
                                            <button onClick={() => setShowEventModal(false)} className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium px-6 py-2.5 rounded-lg transition">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!isHROrAdmin && dateEvents.length === 0 && <div className="text-center py-8 text-gray-400"><FiCalendar className="text-5xl mx-auto mb-2" /><p>No events on this date</p></div>}
                        </div>
                    </div>
                </div>
            )}

            {/* Floating On-Call Notification */}
            {todaysOnCall.length > 0 && (
                <div className="fixed bottom-6 right-6 z-[60] max-w-sm">
                    <div className="bg-white rounded-2xl shadow-2xl border-2 border-red-500 overflow-hidden animate-bounce-slow">
                        <div className="bg-red-600 px-4 py-2 flex justify-between items-center">
                            <div className="flex items-center gap-2 text-white font-bold text-sm">
                                <FiClock className="animate-spin-slow" />
                                <span>ON-CALL REMINDERS</span>
                            </div>
                            <span className="bg-white text-red-600 px-2 py-0.5 rounded-full text-[10px] font-black uppercase">Active</span>
                        </div>
                        <div className="p-4 space-y-3 max-h-60 overflow-y-auto">
                            {todaysOnCall.map((e, idx) => (
                                <div key={idx}
                                    onClick={() => {
                                        const targetDate = new Date();
                                        if (!e.isToday) targetDate.setDate(targetDate.getDate() + 1);

                                        const year = targetDate.getFullYear();
                                        const month = targetDate.getMonth();
                                        const day = targetDate.getDate();

                                        const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

                                        // Update calendar view state
                                        setCurrentMonth(month);
                                        setCalendarYear(year);
                                        setSelectedDate(day);

                                        // Manually filter events for the modal since state updates are async
                                        const events = (calendarEvents || []).filter(ev => {
                                            if (ev.event_type === 'On Call') {
                                                return dateStr >= ev.from_date && dateStr <= ev.to_date;
                                            }
                                            return ev.event_date === dateStr;
                                        }).sort((a, b) => {
                                            const priority = { 'On Call': 0, 'Holiday': 1, 'Floating Holiday': 2 };
                                            return (priority[a.event_type] ?? 10) - (priority[b.event_type] ?? 10);
                                        });

                                        setDateEvents(events);
                                        setShowEventModal(true);
                                        setEventFormData({
                                            event_type: isVerticalHead && !isHROrAdmin ? 'On Call' : 'Event',
                                            event_title: '',
                                            event_description: '',
                                            from_date: dateStr,
                                            to_date: dateStr,
                                            primary_persons: [],
                                            secondary_persons: []
                                        });
                                        setEditingEventId(null);
                                    }}
                                    className="bg-white p-3 rounded-xl border border-gray-100 group hover:bg-gray-100 transition cursor-pointer"
                                >
                                    <div className="flex items-start gap-3">
                                        <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 flex-shrink-0 group-hover:bg-gray-300 transition">
                                            <FiUserCheck />
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <div className="flex items-center justify-between gap-2">
                                                <h5 className="font-bold text-gray-900 text-sm leading-tight truncate">{e.event_title}</h5>
                                                <span className={`px-1.5 py-0.5 rounded text-[8px] font-black uppercase flex-shrink-0 ${e.isToday ? 'bg-gray-600 text-white' : 'bg-amber-500 text-white'}`}>
                                                    {e.isToday ? 'Today' : 'Tomorrow'}
                                                </span>
                                            </div>
                                            <p className="text-xs text-gray-600 mt-1 flex items-center gap-1">
                                                <FiCalendar className="text-[10px]" />
                                                {e.from_date} - {e.to_date}
                                            </p>
                                        </div>
                                    </div>
                                    {(e.primary_names || []).length > 0 && (
                                        <div className="mt-2 flex flex-wrap gap-1 border-t border-indigo-200 pt-2">
                                            {e.primary_names.map((name, i) => (
                                                <span key={i} className="px-2 py-0.5 bg-indigo-600 text-white rounded-full text-[9px] font-bold">{name}</span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="bg-gray-50 px-4 py-2 text-center">
                            <button
                                onClick={() => setTodaysOnCall([])}
                                className="text-[10px] font-bold text-gray-500 hover:text-red-600 uppercase tracking-widest transition"
                            >
                                Dismiss for now
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Delete Event</h3>
                        <p className="text-gray-600 mb-6">Are you sure you want to delete this event? This action cannot be undone.</p>
                        <div className="flex justify-end gap-3">
                            <button onClick={() => { setShowDeleteConfirm(false); setEventToDelete(null); }} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300 font-medium">Cancel</button>
                            <button onClick={confirmDeleteEvent} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium">Delete</button>
                        </div>

                    </div>
                </div>
            )}

            {/* Summary Details Modal */}
            <SummaryDetailsModal
                isOpen={showSummaryModal}
                onClose={() => setShowSummaryModal(false)}
                category={summaryCategory}
                data={summaryDetails}
                loading={summaryDetailLoading}
            />

            <style jsx>{`
        .calendar-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 1px; background-color: #e5e7eb; border: 1px solid #e5e7eb; height: 100%; grid-auto-rows: 1fr; }
        .weekday-header { background-color: #f8fafc; padding: 8px 4px; text-align: center; font-weight: 600; font-size: 0.75rem; color: #6b7280; }
        .calendar-day-cell { background-color: white; padding: 4px; cursor: pointer; transition: background-color 0.2s; position: relative; display: flex; flex-direction: column; overflow: hidden; height: 100%; }
        .calendar-day-cell:hover { background-color: #f2f7fcff; }
        .calendar-day-cell.empty { background-color: #f9fafb; cursor: default; }
        .calendar-day-cell.sunday { background-color: #fef3c7; }
        .calendar-day-cell.on-call-day { background-color: #ffffffff; }
        .calendar-day-cell.today { border: 2px solid #ef4444 !important; z-index: 10; }
        .date-number { font-weight: 600; font-size: 0.75rem; margin-bottom: 2px; color: #374151; }
        .events-container { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
        .event-badge { display: flex; align-items: center; gap: 4px; font-size: 0.7rem; padding: 2px 4px; border-radius: 4px; white-space: nowrap; overflow: hidden; max-width: 100%; box-sizing: border-box; }
        .event-badge.holiday { background-color: #dcfce7; color: #166534; }
        .event-badge.floating-holiday { background-color: #fef3c7; color: #92400e; }
        .event-badge.event { background-color: #dbeafe; color: #1e40af; }
        .event-badge.meeting { background-color: #f3e8ff; color: #6b21a8; }
        .event-badge.deadline { background-color: #fee2e2; color: #991b1b; }
        .event-badge.missing { background-color: #fecaca; color: #7f1d1d; border: 1px solid #ef4444; font-size: 0.6rem; padding: 1px 3px; }
        .event-dot { width: 5px; height: 5px; border-radius: 50%; background-color: currentColor; flex-shrink: 0; }
        .event-text { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex-grow: 1; min-width: 0; }
        .event-more { font-size: 0.65rem; color: #6b7280; margin-top: 1px; }
        .on-call-indicator { background: #e0e7ff; padding: 2px; border-radius: 4px; display: flex; align-items: center; justify-content: center; box-shadow: 0 1px 2px rgba(0,0,0,0.1); }
        @keyframes bounce-slow {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
        }
        @keyframes spin-slow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
        }
        .animate-bounce-slow { animation: bounce-slow 3s ease-in-out infinite; }
        .animate-spin-slow { animation: spin-slow 8s linear infinite; }
      `}</style>

            {/* GitLab Activity Section - Heatmap and 9-Box Grid */}
            {[1, 4].includes(roleId) && (
                <div className="mt-8 border-t border-gray-100 pt-8">
                    <EmployeeGitActivity isHROrAdmin={isHROrAdmin} roleId={roleId} />
                </div>
            )}
        </div>
    );
}

// ==========================================
// Sub-Component: Employee List Tab
// ==========================================
function EmployeeListTab() {
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [empLoading, setEmpLoading] = useState(false);
    // user_id -> { unread_count, latest_reply_at } for unread Performance Revision replies
    const [prUnreadByEmployee, setPrUnreadByEmployee] = useState({});

    // Search & Filter State
    const [searchTerm, setSearchTerm] = useState(() => {
        return localStorage.getItem('emp_list_search_term') || '';
    });
    const [statusFilter, setStatusFilter] = useState(() => {
        return localStorage.getItem('emp_list_status_filter') || 'active';
    });

    // Pagination & Sorting State
    const [currentPage, setCurrentPage] = useState(() => {
        const saved = localStorage.getItem('emp_list_current_page');
        return saved ? Number(saved) : 1;
    });
    const [itemsPerPage, setItemsPerPage] = useState(() => {
        const saved = localStorage.getItem('emp_list_items_per_page');
        return saved ? Number(saved) : 10;
    });
    const [sortConfig, setSortConfig] = useState(() => {
        const saved = localStorage.getItem('emp_list_sort_config');
        try {
            return saved ? JSON.parse(saved) : { key: null, direction: 'asc' };
        } catch (e) {
            return { key: null, direction: 'asc' };
        }
    });

    useEffect(() => {
        localStorage.setItem('emp_list_search_term', searchTerm);
    }, [searchTerm]);

    useEffect(() => {
        localStorage.setItem('emp_list_status_filter', statusFilter);
    }, [statusFilter]);

    useEffect(() => {
        localStorage.setItem('emp_list_current_page', currentPage);
    }, [currentPage]);

    useEffect(() => {
        localStorage.setItem('emp_list_items_per_page', itemsPerPage);
    }, [itemsPerPage]);

    useEffect(() => {
        localStorage.setItem('emp_list_sort_config', JSON.stringify(sortConfig));
    }, [sortConfig]);

    // Modals
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [statusModalData, setStatusModalData] = useState(null);
    const [relievingDate, setRelievingDate] = useState('');
    const [relievingReason, setRelievingReason] = useState('');
    const [selectedEmployeeForIdCard, setSelectedEmployeeForIdCard] = useState(null);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]); // Bulk Selection
    const [isIdCardOpen, setIsIdCardOpen] = useState(false);

    // Visibility Flag State
    const [showFlagModal, setShowFlagModal] = useState(false);
    const [flagModalData, setFlagModalData] = useState(null);

    // Status Dropdown State
    const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
    const statusDropdownRef = React.useRef(null);

    const statusOptions = [
        { value: 'all', label: 'All Employees', icon: FiUsers, color: 'text-blue-600', bg: 'bg-blue-50', border: 'border-blue-100' },
        { value: 'active', label: 'Active Only', icon: FiUserCheck, color: 'text-green-600', bg: 'bg-green-50', border: 'border-green-100' },
        { value: 'inactive', label: 'Inactive Only', icon: FiX, color: 'text-red-600', bg: 'bg-red-50', border: 'border-red-100' },
        { value: 'flagged', label: 'Inactive with Flag', icon: FiFlag, color: 'text-amber-600', bg: 'bg-amber-50', border: 'border-amber-100' },
        { value: 'active_flagged', label: 'Active with Flag', icon: FiFlag, color: 'text-rose-600', bg: 'bg-rose-50', border: 'border-rose-100' },
    ];

    const currentStatus = statusOptions.find(opt => opt.value === statusFilter) || statusOptions[0];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setIsStatusDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        fetchEmployees();
        fetchPrUnreadPriority();
        const onAlertsChanged = () => fetchPrUnreadPriority();
        window.addEventListener('perf-revision-alerts-changed', onAlertsChanged);
        return () => window.removeEventListener('perf-revision-alerts-changed', onAlertsChanged);
    }, []);

    const fetchEmployees = async () => {
        setEmpLoading(true);
        try {
            const res = await api.get('/hrms/employee-list');
            if (res.data.status) setEmployees(res.data.data);
        } catch (error) {
            console.error(error);
            toast.error('Failed to fetch employee list');
        } finally {
            setEmpLoading(false);
        }
    };

    const fetchPrUnreadPriority = async () => {
        try {
            const res = await api.get('/employee/performance-revision-alerts');
            if (!res.data?.status) return;
            const map = {};
            (res.data.data?.by_employee || []).forEach((row) => {
                const uid = String(row.user_id);
                map[uid] = {
                    unread_count: Number(row.unread_count) || 0,
                    latest_reply_at: row.latest_reply_at || null,
                };
            });
            setPrUnreadByEmployee(map);
        } catch (error) {
            console.error('Failed to fetch PR unread priority', error);
        }
    };

    const calculateExperience = (joiningDate, relievingDate) => {
        if (!joiningDate) return '-';
        const start = new Date(joiningDate);
        const end = relievingDate ? new Date(relievingDate) : new Date();
        const years = differenceInYears(end, start);
        const months = differenceInMonths(end, start) % 12;
        return `${years}y ${months}m`;
    };

    // Filter Logic
    const filteredEmployees = employees.filter(emp => {
        const search = searchTerm.toLowerCase();
        const fullName = `${emp.first_name} ${emp.last_name}`.toLowerCase();
        const matchesSearch = fullName.includes(search) ||
            (emp.email && emp.email.toLowerCase().includes(search)) ||
            (emp.designation && emp.designation.toLowerCase().includes(search)) ||
            (String(emp.user_id).includes(search));

        let matchesStatus = true;
        // Check for loose equality to handle string '0'/'1' or number 0/1
        const status = Number(emp.account_status);
        const flag = emp.attendance_flag;

        if (statusFilter === 'active') {
            // status 1 is active, flag is not 0 (not hidden)
            matchesStatus = (status === 1 && flag != 0);
        } else if (statusFilter === 'inactive') {
            // status 0 or 2 is inactive, flag is not 0 (not hidden)
            matchesStatus = ((status === 0 || status === 2) && flag != 0);
        } else if (statusFilter === 'flagged') {
            // inactive with flag (status === 0 or 2 && flag == 0)
            matchesStatus = ((status === 0 || status === 2) && flag == 0);
        } else if (statusFilter === 'active_flagged') {
            // active with flag (status === 1 && flag == 0)
            matchesStatus = (status === 1 && flag == 0);
        }

        return matchesSearch && matchesStatus;
    });

    // Sorting Logic (+ pin employees with unread Performance Revision replies to top)
    const sortedEmployees = React.useMemo(() => {
        let sortableItems = [...filteredEmployees];
        if (sortConfig.key !== null) {
            sortableItems.sort((a, b) => {
                let aVal = a[sortConfig.key];
                let bVal = b[sortConfig.key];

                if (sortConfig.key === 'name') {
                    aVal = `${a.first_name} ${a.last_name}`.toLowerCase();
                    bVal = `${b.first_name} ${b.last_name}`.toLowerCase();
                } else if (sortConfig.key === 'experience') {
                    const getDur = (emp) => {
                        if (!emp.joining_date) return 0;
                        const start = new Date(emp.joining_date).getTime();
                        const end = emp.relieving_date ? new Date(emp.relieving_date).getTime() : new Date().getTime();
                        return end - start;
                    };
                    aVal = getDur(a);
                    bVal = getDur(b);
                } else {
                    // Safe string conversion for generic sort
                    aVal = String(aVal || '').toLowerCase();
                    bVal = String(bVal || '').toLowerCase();
                }

                if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
                if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }

        // Notification pin: unread employee replies only — most recent reply first
        if (Object.keys(prUnreadByEmployee).length === 0) {
            return sortableItems;
        }

        const withUnread = [];
        const withoutUnread = [];
        for (const emp of sortableItems) {
            if (prUnreadByEmployee[String(emp.user_id)]) {
                withUnread.push(emp);
            } else {
                withoutUnread.push(emp);
            }
        }
        withUnread.sort((a, b) => {
            const aAt = prUnreadByEmployee[String(a.user_id)]?.latest_reply_at || '';
            const bAt = prUnreadByEmployee[String(b.user_id)]?.latest_reply_at || '';
            return String(bAt).localeCompare(String(aAt));
        });
        return [...withUnread, ...withoutUnread];
    }, [filteredEmployees, sortConfig, prUnreadByEmployee]);

    // Pagination Logic
    const totalPages = Math.ceil(sortedEmployees.length / itemsPerPage);

    useEffect(() => {
        if (totalPages > 0 && currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [totalPages, currentPage]);

    const paginatedEmployees = sortedEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const handlePageChange = (pageNum) => {
        setCurrentPage(pageNum);
    };

    const handleExportExcel = async () => {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Employee List');

            // Determine Title based on Filter
            let reportTitle = 'Employee List';
            if (statusFilter === 'active') reportTitle = 'Active Employee List';
            else if (statusFilter === 'inactive') reportTitle = 'Inactive Employee List';
            else if (statusFilter === 'flagged') reportTitle = 'Inactive Flagged Employee Report';
            else if (statusFilter === 'active_flagged') reportTitle = 'Active Flagged Employee Report';

            // 1. Title
            worksheet.mergeCells('A1:I1'); // Expanded to I (added 1 column)
            const titleCell = worksheet.getCell('A1');
            // Fallback text if logo logic is complex client-side (as per requirement: "if logo unavailable, fall back to text")
            // We use the text as the primary header here.
            titleCell.value = 'eNova Software and Hardware Solutions P Ltd';
            titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
            titleCell.font = { name: 'Arial', size: 16, bold: true };

            // 2. SubTitle
            worksheet.mergeCells('A2:I2');
            const subTitleCell = worksheet.getCell('A2');
            subTitleCell.value = reportTitle;
            subTitleCell.alignment = { vertical: 'middle', horizontal: 'center' };
            subTitleCell.font = { name: 'Arial', size: 12, bold: true };

            // 3. Generation Date
            worksheet.mergeCells('A3:I3');
            const dateCell = worksheet.getCell('A3');
            dateCell.value = `Generated on: ${new Date().toLocaleString()}`;
            dateCell.alignment = { vertical: 'middle', horizontal: 'center' };
            dateCell.font = { name: 'Arial', size: 10, bold: false };

            // Spacer
            worksheet.addRow([]);

            // 4. Headers
            const headerTerms = ['ID', 'Name', 'Designation', 'Reporting Manager', 'Email', 'Mobile', 'Join Date', 'Relieving Date', 'Reason for Relieving', 'Experience', 'Status'];
            const headerRow = worksheet.addRow(headerTerms);

            headerRow.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
                cell.border = { bottom: { style: 'thin' } };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFEEEEEE' }
                };
            });

            // 5. Data
            sortedEmployees.forEach(emp => {
                const isFlagged = (emp.attendance_flag == 0);
                const statusText = emp.account_status == 1 ? 'Active' : 'Inactive';
                // Add Flag Emoji if flagged
                const statusDisplay = isFlagged ? `🚩 ${statusText}` : statusText;

                worksheet.addRow([
                    emp.user_id,
                    `${emp.first_name} ${emp.last_name}`,
                    emp.designation,
                    emp.reporting_manager || '-', // New Column
                    emp.email,
                    emp.mobile,
                    emp.joining_date,
                    emp.relieving_date || '-',
                    emp.relieving_reason || '-',
                    calculateExperience(emp.joining_date, emp.relieving_date),
                    statusDisplay
                ]);
            });

            // 6. Column Widths & Alignment
            worksheet.columns = [
                { header: 'ID', key: 'id', width: 10, style: { alignment: { horizontal: 'center' } } },
                { header: 'Name', key: 'name', width: 25, style: { alignment: { horizontal: 'left' } } },
                { header: 'Designation', key: 'designation', width: 25, style: { alignment: { horizontal: 'left' } } },
                { header: 'Reporting Manager', key: 'manager', width: 30, style: { alignment: { horizontal: 'left' } } },
                { header: 'Email', key: 'email', width: 35, style: { alignment: { horizontal: 'left' } } },
                { header: 'Mobile', key: 'mobile', width: 15, style: { alignment: { horizontal: 'center' } } },
                { header: 'Join Date', key: 'join_date', width: 15, style: { alignment: { horizontal: 'center' } } },
                { header: 'Relieving Date', key: 'relieving_date', width: 15, style: { alignment: { horizontal: 'center' } } },
                { header: 'Reason for Relieving', key: 'relieving_reason', width: 25, style: { alignment: { horizontal: 'left' } } },
                { header: 'Experience', key: 'exp', width: 15, style: { alignment: { horizontal: 'center' } } },
                { header: 'Status', key: 'status', width: 15, style: { alignment: { horizontal: 'center' } } }
            ];

            // Re-apply header styles because worksheet.columns might reset them
            headerRow.eachCell((cell) => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'center' };
                cell.border = { bottom: { style: 'thin' } };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFEEEEEE' }
                };
            });

            // 7. Write and Save
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `${reportTitle.replace(/ /g, '_')}_${new Date().toISOString().slice(0, 10)}.xlsx`);
        } catch (error) {
            console.error("Excel Export Error:", error);
            toast.error("Failed to export Excel");
        }
    };

    const handleExportPDF = async () => {
        try {
            const loadingToast = toast.loading('Generating PDF...');
            const params = new URLSearchParams();
            if (searchTerm) params.append('search', searchTerm);
            if (statusFilter && statusFilter !== 'all') params.append('status', statusFilter);

            const response = await api.get(`/hrms/export-employee-list-pdf?${params.toString()}`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Employee_List.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            toast.success('PDF Downloaded', { id: loadingToast });
        } catch (error) {
            console.error('PDF Export Error:', error);
            toast.error('Failed to export PDF');
        }
    };

    const handleStatusToggle = (e, empId, currentStatus) => {
        e.stopPropagation();
        const newStatus = currentStatus == 1 ? 0 : 1;
        setStatusModalData({ empId, newStatus });
        setShowStatusModal(true);
    };

    const handleFlagClick = (e, empId, currentFlag) => {
        e.stopPropagation();
        // Default to 1 (Visible) if undefined
        const currentVal = (currentFlag === undefined || currentFlag === null) ? 1 : parseInt(currentFlag);
        const newFlag = currentVal === 1 ? 0 : 1;
        setFlagModalData({ empId, newFlag });
        setShowFlagModal(true);
    };

    const confirmFlagChange = async () => {
        if (!flagModalData) return;
        const { empId, newFlag } = flagModalData;
        try {
            const res = await api.post('/hrms/toggle-attendance-flag', { user_id: empId, flag: newFlag });
            if (res.data.status) {
                toast.success('Visibility updated successfully');
                setEmployees(prev => prev.map(emp => emp.user_id === empId ? { ...emp, attendance_flag: newFlag } : emp));
                setShowFlagModal(false);
                setFlagModalData(null);
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to update visibility');
            setShowFlagModal(false);
        }
    };

    const confirmStatusChange = async () => {
        if (!statusModalData) return;
        const { empId, newStatus } = statusModalData;
        try {
            const payload = { user_id: empId, status: newStatus };
            if (newStatus === 0 || newStatus === 2) {
                if (relievingDate) payload.relieving_date = relievingDate;
                if (relievingReason) payload.relieving_reason = relievingReason;
            }
            const res = await api.post('/hrms/toggle-status', payload);
            if (res.data.status) {
                toast.success('Status updated successfully');
                setEmployees(prev => prev.map(emp => emp.user_id === empId ? {
                    ...emp,
                    account_status: newStatus,
                    joining_date: newStatus === 1 ? new Date().toISOString().split('T')[0] : emp.joining_date,
                    relieving_date: (newStatus === 0 || newStatus === 2) ? relievingDate : null,
                    relieving_reason: (newStatus === 0 || newStatus === 2) ? relievingReason : null
                } : emp));
                setShowStatusModal(false);
                setStatusModalData(null);
                setRelievingDate('');
                setRelievingReason('');
            }
        } catch (error) {
            console.error(error);
            toast.error('Failed to update status');
            setShowStatusModal(false);
            setRelievingDate('');
            setRelievingReason('');
        }
    };

    // Bulk Selection Handlers
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Select all currently filtered employees
            const allIds = filteredEmployees.map(emp => emp.user_id);
            setSelectedEmployeeIds(allIds);
        } else {
            setSelectedEmployeeIds([]);
        }
    };

    const handleSelectRow = (e, id) => {
        e.stopPropagation();
        if (e.target.checked) {
            setSelectedEmployeeIds(prev => [...prev, id]);
        } else {
            setSelectedEmployeeIds(prev => prev.filter(empId => empId !== id));
        }
    };

    // Helper for Sort Icon
    const SortIcon = ({ column }) => {
        if (sortConfig.key !== column) return <span className="text-gray-300 ml-1"><FiFilter className="inline w-3 h-3 opacity-0 group-hover:opacity-50" /></span>;
        return sortConfig.direction === 'asc'
            ? <FiChevronUp className="inline ml-1 text-blue-600" />
            : <FiChevronDown className="inline ml-1 text-blue-600" />;
    };

    // Helper for Pagination Buttons
    const getPageNumbers = () => {
        const pages = [];
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + 4);

        if (end - start < 4) {
            start = Math.max(1, end - 4);
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    return (
        <div className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col h-full">
            {/* Toolbar */}
            <div className="p-6 border-b border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4 bg-white">
                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2">
                        <h3 className="text-xl font-bold text-gray-800">Employee List</h3>
                        <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">{filteredEmployees.length}</span>
                    </div>
                    {/* Compact Org Chart Button */}

                    <button
                        onClick={() => navigate('/org')}
                        className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 text-gray-600 hover:text-purple-600 hover:border-purple-200 hover:bg-purple-50 rounded-lg transition-all shadow-sm text-xs font-bold uppercase tracking-wider group"
                    >
                        <FiGitMerge className="text-purple-500 group-hover:scale-110 transition-transform" />
                        <span>Org Chart</span>
                    </button>
                </div>

                <div className="flex flex-col md:flex-row items-center gap-3 w-full md:w-auto">
                    {/* Page Size Selector (Moved Top) */}
                    <div className="relative">
                        <select
                            value={itemsPerPage}
                            onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                            className="bg-gray-50 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 py-2 pl-3 pr-8 outline-none cursor-pointer hover:bg-white transition-colors appearance-none"
                            title="Rows per page"
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={999999}>All</option>
                        </select>
                        <FiChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none" size={14} />
                    </div>

                    {/* Status Filter - Premium Animated Dropdown */}
                    <div className="relative" ref={statusDropdownRef}>
                        <button
                            onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
                            className={`flex items-center justify-between gap-3 px-4 py-2.5 min-w-[200px] bg-white border ${isStatusDropdownOpen ? 'border-blue-400 ring-4 ring-blue-50' : 'border-gray-200'} rounded-xl shadow-sm hover:border-blue-300 transition-all duration-300 group`}
                        >
                            <div className="flex items-center gap-2.5">
                                <div className={`p-1.5 rounded-lg ${currentStatus.bg} ${currentStatus.color} transition-colors duration-300`}>
                                    <currentStatus.icon size={16} />
                                </div>
                                <span className="text-sm font-bold text-gray-700 tracking-tight">{currentStatus.label}</span>
                            </div>
                            <motion.div
                                animate={{ rotate: isStatusDropdownOpen ? 180 : 0 }}
                                transition={{ duration: 0.3, ease: "easeInOut" }}
                                className="text-gray-400 group-hover:text-blue-500 transition-colors"
                            >
                                <FiChevronDown size={16} />
                            </motion.div>
                        </button>

                        <AnimatePresence>
                            {isStatusDropdownOpen && (
                                <motion.div
                                    initial={{ opacity: 0, y: 10, scale: 0.95 }}
                                    animate={{ opacity: 1, y: 5, scale: 1 }}
                                    exit={{ opacity: 0, y: 10, scale: 0.95 }}
                                    transition={{ duration: 0.2, ease: "easeOut" }}
                                    className="absolute left-0 right-0 mt-2 p-1.5 bg-white border border-gray-100 rounded-2xl shadow-xl z-[60] backdrop-blur-sm"
                                >
                                    <div className="space-y-1">
                                        {statusOptions.map((option) => (
                                            <button
                                                key={option.value}
                                                onClick={() => {
                                                    setStatusFilter(option.value);
                                                    setCurrentPage(1);
                                                    setIsStatusDropdownOpen(false);
                                                }}
                                                className={`w-full flex items-center justify-between p-2 rounded-xl transition-all duration-200 group/item ${statusFilter === option.value
                                                    ? `${option.bg} ${option.color}`
                                                    : 'hover:bg-gray-50 text-gray-600 hover:text-gray-900'
                                                    }`}
                                            >
                                                <div className="flex items-center gap-3">
                                                    <div className={`p-2 rounded-lg transition-all duration-300 ${statusFilter === option.value ? 'bg-white shadow-sm' : 'bg-gray-100 group-hover/item:bg-white group-hover/item:shadow-sm'}`}>
                                                        <option.icon size={15} />
                                                    </div>
                                                    <span className={`text-[13px] font-semibold ${statusFilter === option.value ? 'font-bold' : ''}`}>
                                                        {option.label}
                                                    </span>
                                                </div>
                                                {statusFilter === option.value && (
                                                    <motion.div
                                                        initial={{ scale: 0 }}
                                                        animate={{ scale: 1 }}
                                                        className="mr-1"
                                                    >
                                                        <FiCheckCircle size={14} className="text-blue-500" />
                                                    </motion.div>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>

                    {/* Search */}
                    <div className="relative w-full md:w-64">
                        <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                            type="text"
                            placeholder="Search employees..."
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 focus:bg-white transition-colors text-sm"
                        />
                    </div>

                    {/* Exports */}
                    <div className="flex gap-2">
                        {selectedEmployeeIds.length > 0 && (
                            <button
                                onClick={() => {
                                    setSelectedEmployeeForIdCard(null); // Clear single selection
                                    setIsIdCardOpen(true);
                                }}
                                className="group flex items-center gap-2 px-4 py-2 bg-[#0F172A] hover:bg-black text-white rounded-lg transition-all shadow-sm"
                                title="Bulk Download ID Cards"
                            >
                                <div className="flex items-center justify-center w-5 h-5 bg-white rounded-full text-[#0F172A] text-xs font-bold">
                                    {selectedEmployeeIds.length}
                                </div>
                                <div className="flex items-center gap-1.5 font-semibold text-sm">
                                    <FaIdCard className="text-white" size={16} />
                                    <span>Bulk Download</span>
                                </div>
                            </button>
                        )}
                        <button onClick={handleExportExcel} className="p-2 text-green-600 rounded hover:bg-green-50 transition-colors shadow-sm border border-gray-200" title="Export to Excel"><RiFileExcelFill size={20} /></button>
                        <button onClick={handleExportPDF} className="p-2 text-red-600 rounded hover:bg-red-50 transition-colors shadow-sm border border-gray-200" title="Export to PDF"><RiFilePdf2Fill size={20} /></button>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto flex-1">
                <table className="w-full text-left border-collapse">
                    <thead className="bg-gray-50 sticky top-0 z-10">
                        <tr className="text-gray-600 text-xs font-bold uppercase tracking-wider border-b border-gray-200">
                            <th className="px-6 py-4">
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={filteredEmployees.length > 0 && selectedEmployeeIds.length === filteredEmployees.length}
                                    className="rounded border-gray-300 text-red-600 focus:ring-red-500 w-4 h-4 cursor-pointer"
                                />
                            </th>
                            <th className="px-6 py-4 cursor-pointer group hover:bg-gray-100 transition-colors" onClick={() => requestSort('name')}>
                                Employee <SortIcon column="name" />
                            </th>
                            <th className="px-6 py-4 cursor-pointer group hover:bg-gray-100 transition-colors" onClick={() => requestSort('user_id')}>
                                ID <SortIcon column="user_id" />
                            </th>
                            <th className="px-6 py-4 cursor-pointer group hover:bg-gray-100 transition-colors" onClick={() => requestSort('designation')}>
                                Designation <SortIcon column="designation" />
                            </th>
                            <th className="px-6 py-4">Reporting_to</th>
                            <th className="px-6 py-4 cursor-pointer group hover:bg-gray-100 transition-colors" onClick={() => requestSort('joining_date')}>
                                Join Date <SortIcon column="joining_date" />
                            </th>
                            <th className="px-6 py-4 cursor-pointer group hover:bg-gray-100 transition-colors" onClick={() => requestSort('relieving_date')}>
                                Relieving Date <SortIcon column="relieving_date" />
                            </th>
                            <th className="px-6 py-4 cursor-pointer group hover:bg-gray-100 transition-colors" onClick={() => requestSort('experience')}>
                                Experience <SortIcon column="experience" />
                            </th>
                            <th className="px-6 py-4">Contact</th>
                            <th className="px-6 py-4 text-center">ID Card</th>
                            <th className="px-6 py-4 text-center cursor-pointer group hover:bg-gray-100 transition-colors" onClick={() => requestSort('account_status')}>
                                Status <SortIcon column="account_status" />
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {empLoading ? (
                            <tr><td colSpan="11" className="px-6 py-20 text-center text-gray-500"><div className="flex flex-col justify-center items-center gap-3"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div><span>Loading employees...</span></div></td></tr>
                        ) : paginatedEmployees.length === 0 ? (
                            <tr>
                                <td colSpan="11" className="px-6 py-20 text-center text-gray-500">
                                    <div className="flex flex-col items-center justify-center">
                                        <div className="bg-gray-100 p-4 rounded-full mb-3"><FiUsers className="text-3xl text-gray-400" /></div>
                                        <p className="text-lg font-medium text-gray-900">No employees found</p>
                                        <p className="text-sm text-gray-500 mt-1">Try adjusting your search or filters</p>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            paginatedEmployees.map((emp) => {
                                const prUnread = prUnreadByEmployee[String(emp.user_id)];
                                return (
                                    <tr key={emp.user_id} onClick={() => navigate(`/employee-details?user_id=${emp.user_id}`)} className={`hover:bg-blue-50/50 cursor-pointer transition-colors group ${selectedEmployeeIds.includes(emp.user_id) ? 'bg-blue-50' : ''} ${prUnread ? 'bg-[#fff5f6]' : ''}`}>
                                        <td className="px-6 py-4" onClick={(e) => e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                onChange={(e) => handleSelectRow(e, emp.user_id)}
                                                checked={selectedEmployeeIds.includes(emp.user_id)}
                                                className="rounded border-gray-300 text-red-600 focus:ring-red-500 w-4 h-4 cursor-pointer"
                                            />
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center gap-3">
                                                {emp.profile_image ? (
                                                    <img src={emp.profile_image} alt="" className="w-10 h-10 rounded-full object-cover border border-gray-200 shadow-sm" />
                                                ) : (
                                                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center text-blue-700 font-bold border border-white shadow-sm ring-1 ring-blue-50 text-sm">
                                                        {emp.first_name?.[0]}{emp.last_name?.[0]}
                                                    </div>
                                                )}
                                                <div>
                                                    <div className="flex items-center gap-2">
                                                        <p className="font-semibold text-gray-900 text-sm">{emp.first_name} {emp.last_name}</p>
                                                        {prUnread && (
                                                            <span
                                                                className="flex h-5 min-w-[1.25rem] px-1 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white"
                                                                title="Unread Performance Revision reply"
                                                            >
                                                                {prUnread.unread_count > 99 ? '99+' : prUnread.unread_count}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <p className="text-xs text-gray-500 group-hover:text-blue-600 transition-colors" title={emp.email}>{emp.email}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <span className="font-mono text-xs font-medium bg-gray-100 text-gray-600 px-2 py-1 rounded border border-gray-200">
                                                #{String(emp.user_id).padStart(4, '0')}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex flex-col items-start leading-tight">
                                                {emp.official_job_role && emp.job_role && (emp.official_job_role.trim().toLowerCase() !== emp.job_role.trim().toLowerCase()) && (
                                                    <span className="text-[10px] text-gray-400 line-through decoration-gray-300 mb-0.5" title="Employee Entered Role">
                                                        {emp.job_role}
                                                    </span>
                                                )}
                                                <span className={`text-sm font-medium ${emp.official_job_role ? 'text-gray-900' : 'text-gray-700'}`}>
                                                    {emp.designation || <span className="text-gray-400 italic">None</span>}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-xs text-gray-600" title={emp.reporting_manager}>
                                            {emp.reporting_manager || '-'}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-600">
                                            {emp.joining_date ? new Date(emp.joining_date).toLocaleDateString('en-GB') : '-'}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-600">
                                            {emp.relieving_date ? new Date(emp.relieving_date).toLocaleDateString('en-GB') : '-'}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-600">
                                            {calculateExperience(emp.joining_date, emp.relieving_date)}
                                        </td>
                                        <td className="px-6 py-4 text-sm text-gray-600">
                                            <div className="flex flex-col gap-1.5">
                                                {emp.mobile ? (
                                                    <div className="flex items-center gap-2 text-xs">
                                                        <FiPhone className="text-gray-400" size={12} />
                                                        <span>{emp.mobile}</span>
                                                    </div>
                                                ) : <span className="text-gray-400 text-xs italic">No phone</span>}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-center" onClick={(e) => e.stopPropagation()}>
                                            <button
                                                onClick={() => {
                                                    setSelectedEmployeeForIdCard(emp.user_id);
                                                    setSelectedEmployeeIds([]); // Clear bulk selection if clicking single icon
                                                    setIsIdCardOpen(true);
                                                }}
                                                className="p-1.5 text-red-600 hover:bg-red-50 rounded-full transition-all"
                                                title="Generate ID Card"
                                            >
                                                <FaIdCard size={18} />
                                            </button>
                                        </td>
                                        <td className="px-6 py-4 text-center" onClick={(e) => e.stopPropagation()}>
                                            <div className="flex flex-col items-center gap-1">
                                                <div className="flex items-center gap-2">
                                                    <button
                                                        onClick={(e) => handleStatusToggle(e, emp.user_id, emp.account_status)}
                                                        className={`relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${emp.account_status == 1 ? 'bg-green-500' : 'bg-gray-200'}`}
                                                        title={emp.account_status == 1 ? "Deactivate User" : "Activate User"}
                                                    >
                                                        <span aria-hidden="true" className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${emp.account_status == 1 ? 'translate-x-4' : 'translate-x-0'}`} />
                                                    </button>

                                                    <button
                                                        onClick={(e) => handleFlagClick(e, emp.user_id, emp.attendance_flag)}
                                                        className={`p-1 rounded hover:bg-gray-100 transition-colors ${(emp.attendance_flag === undefined || emp.attendance_flag == 1)
                                                            ? 'text-gray-300 hover:text-blue-500'
                                                            : 'text-red-500 bg-red-50 hover:bg-red-100'
                                                            }`}
                                                        title={(emp.attendance_flag === undefined || emp.attendance_flag == 1)
                                                            ? "Visible in Reports/Attendance"
                                                            : "Hidden from Reports/Attendance"
                                                        }
                                                    >
                                                        <FiFlag size={14} fill={(emp.attendance_flag === undefined || emp.attendance_flag == 1) ? "none" : "currentColor"} />
                                                    </button>
                                                </div>
                                                <span className={`text-[10px] font-bold uppercase tracking-wide ${emp.account_status == 1 ? 'text-green-600' : 'text-gray-400'}`}>
                                                    {emp.account_status == 1 ? 'Active' : 'Inactive'}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            <div className="border-t border-gray-200 px-6 py-4 bg-gray-50 flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-3 text-sm text-gray-600">
                    <span className="hidden md:inline">
                        Showing <span className="font-semibold text-gray-900">{filteredEmployees.length > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0}</span> to <span className="font-semibold text-gray-900">{Math.min(currentPage * itemsPerPage, filteredEmployees.length)}</span> of <span className="font-semibold text-gray-900">{filteredEmployees.length}</span> results
                    </span>
                </div>

                <div className="flex items-center gap-1">
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                        disabled={currentPage === 1}
                        className="p-2 rounded hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed text-gray-600 transition"
                    >
                        <FiChevronLeft />
                    </button>

                    <div className="flex items-center gap-1">
                        {getPageNumbers().map(pageNum => (
                            <button
                                key={pageNum}
                                onClick={() => setCurrentPage(pageNum)}
                                className={`w-8 h-8 rounded text-sm font-medium transition-colors ${currentPage === pageNum
                                    ? 'bg-[#C30010] text-white shadow-sm'
                                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
                                    }`}
                            >
                                {pageNum}
                            </button>
                        ))}
                    </div>

                    <button
                        onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                        disabled={currentPage === totalPages || totalPages === 0}
                        className="p-2 rounded hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed text-gray-600 transition"
                    >
                        <FiChevronRight />
                    </button>
                </div>
            </div>

            {/* ID Card Modal */}
            {isIdCardOpen && (
                <IdCard
                    employeeId={selectedEmployeeForIdCard}
                    employeeIds={selectedEmployeeIds} // Pass bulk IDs
                    isOpen={isIdCardOpen}
                    onClose={() => setIsIdCardOpen(false)}
                    onUpdateSuccess={fetchEmployees}
                />
            )}

            {/* Status Modal Confirm */}
            {showStatusModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] p-4 backdrop-blur-sm">
                    <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6 animate-in fade-in zoom-in duration-200 border border-gray-100">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Confirm Status Change</h3>
                        <p className="text-gray-600 mb-4 leading-relaxed text-sm">
                            Are you sure you want to <strong>{statusModalData?.newStatus === 1 ? 'activate' : 'deactivate'}</strong> this employee?
                            {(statusModalData?.newStatus === 0 || statusModalData?.newStatus === 2) && <span className="block mt-2 text-red-500 text-[11px] font-medium bg-red-50 p-2 rounded">Warning: They will lose access to the system immediately.</span>}
                        </p>
                        {(statusModalData?.newStatus === 0 || statusModalData?.newStatus === 2) && (
                            <>
                                <div className="mb-4">
                                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">
                                        Relieving Date <span className="text-red-500">*</span>
                                    </label>
                                    <div className="relative">
                                        <DatePicker
                                            selected={relievingDate ? new Date(relievingDate) : null}
                                            onChange={(date) => setRelievingDate(formatDateToString(date))}
                                            maxDate={new Date()}
                                            dateFormat="dd/MM/yyyy"
                                            required
                                            className="w-full pl-3 pr-10 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-red-500 focus:border-red-500 text-sm outline-none cursor-pointer"
                                            calendarClassName="relieving-datepicker"
                                            placeholderText="Select Relieving Date"
                                            renderCustomHeader={({
                                                date,
                                                changeYear,
                                                changeMonth,
                                                decreaseMonth,
                                                increaseMonth,
                                                prevMonthButtonDisabled,
                                                nextMonthButtonDisabled,
                                            }) => (
                                                <div className="flex items-center justify-between px-3 py-2 bg-white border-b border-gray-100">
                                                    <button
                                                        onClick={decreaseMonth}
                                                        disabled={prevMonthButtonDisabled}
                                                        type="button"
                                                        className="p-1 hover:bg-slate-100 rounded-lg transition-colors disabled:opacity-35"
                                                    >
                                                        <FiChevronLeft className="w-4 h-4 text-slate-600" />
                                                    </button>
                                                    <div className="flex gap-2">
                                                        <select
                                                            value={date.getMonth()}
                                                            onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                            className="px-2 py-1 text-xs font-bold text-slate-700 bg-white border border-slate-200 rounded-lg outline-none cursor-pointer hover:border-slate-300 transition-colors"
                                                        >
                                                            {headerMonths
                                                                .map((month, index) => ({ month, index }))
                                                                .filter(({ index }) => {
                                                                    if (date.getFullYear() === new Date().getFullYear()) {
                                                                        return index <= new Date().getMonth();
                                                                    }
                                                                    return true;
                                                                })
                                                                .map(({ month, index }) => (
                                                                    <option key={month} value={index}>
                                                                        {month}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                        <select
                                                            value={date.getFullYear()}
                                                            onChange={({ target: { value } }) => changeYear(Number(value))}
                                                            className="px-2 py-1 text-xs font-bold text-slate-700 bg-white border border-slate-200 rounded-lg outline-none cursor-pointer hover:border-slate-300 transition-colors"
                                                        >
                                                            {headerYears.map((year) => (
                                                                <option key={year} value={year}>
                                                                    {year}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <button
                                                        onClick={increaseMonth}
                                                        disabled={nextMonthButtonDisabled}
                                                        type="button"
                                                        className="p-1 hover:bg-slate-100 rounded-lg transition-colors disabled:opacity-35"
                                                    >
                                                        <FiChevronRight className="w-4 h-4 text-slate-600" />
                                                    </button>
                                                </div>
                                            )}
                                        />
                                        <FiCalendar className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none w-4 h-4" />
                                    </div>
                                </div>
                                <div className="mb-5">
                                    <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">
                                        Reason for Relieving <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={relievingReason}
                                        onChange={(e) => setRelievingReason(e.target.value)}
                                        placeholder="e.g. Resignation, Termination, Retirement, Personal Reasons"
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-red-500 focus:border-red-500 text-sm outline-none"
                                    />
                                </div>
                            </>
                        )}
                        <div className="flex justify-end gap-3">
                            <button onClick={() => { setShowStatusModal(false); setRelievingDate(''); setRelievingReason(''); }} className="px-5 py-2.5 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition text-sm">Cancel</button>
                            <button
                                onClick={confirmStatusChange}
                                disabled={(statusModalData?.newStatus === 0 || statusModalData?.newStatus === 2) && (!relievingDate || !relievingReason.trim())}
                                className={`px-5 py-2.5 text-white font-medium rounded-lg transition shadow-md hover:shadow-lg text-sm ${(statusModalData?.newStatus === 0 || statusModalData?.newStatus === 2) && (!relievingDate || !relievingReason.trim())
                                    ? 'bg-gray-400 cursor-not-allowed shadow-none hover:shadow-none'
                                    : statusModalData?.newStatus === 1
                                        ? 'bg-green-600 hover:bg-green-700'
                                        : 'bg-red-600 hover:bg-red-700'
                                    }`}
                            >
                                Yes, Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Visibility Flag Modal */}
            {showFlagModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100] p-4 backdrop-blur-sm">
                    <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6 animate-in fade-in zoom-in duration-200 border border-gray-100">
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Confirm Visibility Change</h3>
                        <p className="text-gray-600 mb-6 leading-relaxed">
                            Are you sure you want to <strong>{flagModalData?.newFlag === 1 ? 'Show' : 'Hide'}</strong> this employee in Attendance & Reports?
                            {flagModalData?.newFlag === 0 && <span className="block mt-2 text-amber-600 text-sm font-medium bg-amber-50 p-2 rounded">Note: They will be hidden from Attendance, Leaves, and Reports but remain Active.</span>}
                        </p>
                        <div className="flex justify-end gap-3">
                            <button onClick={() => setShowFlagModal(false)} className="px-5 py-2.5 text-gray-700 font-medium hover:bg-gray-100 rounded-lg transition">Cancel</button>
                            <button onClick={confirmFlagChange} className={`px-5 py-2.5 text-white font-medium rounded-lg transition shadow-md hover:shadow-lg bg-red-600 hover:bg-red-700`}>Yes, Update</button>
                        </div>
                    </div>
                </div>
            )}
            <style>{`
                .react-datepicker-wrapper {
                    width: 100%;
                }
                .react-datepicker__popper {
                    z-index: 100000 !important;
                }
                .relieving-datepicker {
                    border: 1px solid #e2e8f0;
                    border-radius: 16px;
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
                    font-family: inherit;
                    background: #ffffff;
                }
                .relieving-datepicker .react-datepicker__header {
                    background: #ffffff;
                    border-bottom: 1px solid #f1f5f9;
                    padding-top: 12px;
                    padding-bottom: 0px;
                    border-top-left-radius: 16px;
                    border-top-right-radius: 16px;
                }
                .relieving-datepicker .react-datepicker__day-names {
                    display: flex;
                    justify-content: space-around;
                    padding: 0 10px;
                }
                .relieving-datepicker .react-datepicker__month {
                    margin: 0.4rem;
                }
                .relieving-datepicker .react-datepicker__day-name {
                    color: #94a3b8;
                    font-weight: 700;
                    font-size: 11px;
                    width: 2.25rem;
                    line-height: 2.25rem;
                    margin: 0.1rem;
                    text-align: center;
                    text-transform: uppercase;
                }
                .relieving-datepicker .react-datepicker__week {
                    display: flex;
                    justify-content: space-around;
                }
                .relieving-datepicker .react-datepicker__day {
                    color: #334155;
                    font-weight: 600;
                    font-size: 13px;
                    width: 2.25rem;
                    line-height: 2.25rem;
                    margin: 0.1rem;
                    border-radius: 9999px;
                    text-align: center;
                    transition: all 0.2s;
                    cursor: pointer;
                }
                .relieving-datepicker .react-datepicker__day--selected,
                .relieving-datepicker .react-datepicker__day--keyboard-selected {
                    background: #b91c1c !important;
                    color: #ffffff !important;
                    box-shadow: 0 4px 10px rgba(185, 28, 28, 0.3);
                }
                .relieving-datepicker .react-datepicker__day:hover {
                    background: #fee2e2;
                    color: #b91c1c;
                }
                .relieving-datepicker .react-datepicker__day--outside-month {
                    color: #cbd5e1;
                }
                .relieving-datepicker .react-datepicker__day--disabled {
                    color: #cbd5e1 !important;
                    background: transparent !important;
                    cursor: not-allowed !important;
                    opacity: 0.4;
                }
                .relieving-datepicker .react-datepicker__day--disabled:hover {
                    background: transparent !important;
                    color: #cbd5e1 !important;
                }
            `}</style>
        </div>
    );
}

// ==========================================
// Sub-Component: Summary Details Modal
// ==========================================
function SummaryDetailsModal({ isOpen, onClose, category, data, loading }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-[100] p-4">
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-white rounded-xl shadow-xl max-w-md w-full overflow-hidden flex flex-col"
            >
                <div className="px-5 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50">
                    <h3 className="font-bold text-gray-800 text-sm italic">{category.label}</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <FiX size={18} />
                    </button>
                </div>

                <div className="p-2 max-h-[50vh] overflow-y-auto">
                    {loading ? (
                        <div className="text-center py-6 text-gray-400 text-xs">Loading...</div>
                    ) : data.length > 0 ? (
                        <div className="divide-y divide-gray-50">
                            {data.map((item, idx) => (
                                <div key={idx} className="py-2 px-3 hover:bg-gray-50 transition-colors">
                                    <div className="flex justify-between items-center mb-0.5">
                                        <span className="text-[10px] font-black text-gray-400 uppercase tracking-tighter">
                                            {item.attendance_date || item.date || item.from_date}
                                        </span>
                                        <span className="text-[10px] font-black text-red-600 bg-red-50 px-1.5 rounded">
                                            {item.duration || item.duration_hrs || item.first_punch || ''} {item.duration_hrs ? 'h' : item.duration ? 'd' : ''}
                                        </span>
                                    </div>
                                    <p className="text-[11px] font-medium text-gray-700 leading-tight">
                                        {item.reason || item.detail || item.type || 'Regular entry'}
                                    </p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-6 text-gray-400 text-xs">No records found</div>
                    )}
                </div>

                <div className="px-4 py-2 border-t border-gray-50 flex justify-end">
                    <button onClick={onClose} className="text-[10px] font-black text-gray-400 hover:text-gray-900 uppercase">Dismiss</button>
                </div>
            </motion.div>
        </div>
    );
}

// ==========================================
// Sub-Component: Stat Card
// ==========================================
function StatCard({ icon, title, value, color, loading }) {
    const colorClasses = {
        blue: 'bg-blue-100 text-blue-600',
        green: 'bg-green-100 text-green-600',
        purple: 'bg-purple-100 text-purple-600',
        amber: 'bg-amber-100 text-amber-600'
    };

    return (
        <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition p-4 sm:p-6">
            <div className="flex items-center justify-between">
                <div className="flex-1">
                    <p className="text-gray-500 text-sm font-medium mb-2">{title}</p>
                    {loading ? <div className="h-8 w-20 bg-gray-200 animate-pulse rounded"></div> : <h3 className="text-3xl font-bold text-gray-800">{value}</h3>}
                </div>
                <div className={`w-14 h-14 rounded-lg flex items-center justify-center ${colorClasses[color]}`}>{icon}</div>
            </div>
        </div>
    );
}

//completed
// Export Main Component
export default HrmsDashboard;
